webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationVue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var RegistrationVue = (function (_super) {
    __extends(RegistrationVue, _super);
    function RegistrationVue() {
        return _super.call(this) || this;
    }
    RegistrationVue.prototype.mounted = function () {
        var _this = this;
        var preservedY = this.$store.state.scrolls[this.$route.path];
        if (this.$route.query.routerback && preservedY) {
            window.scroll(0, preservedY);
        }
        else {
            window.scroll(0, 0);
        }
        this.scrollEvent = window.addEventListener('scroll', function () {
            if (_this.$store) {
                _this.$store.state.scrolls[_this.$route.path] = window.scrollY;
            }
        });
    };
    RegistrationVue.prototype.beforeDestroy = function () {
        window.removeEventListener('scroll', this.scrollEvent);
    };
    RegistrationVue.prototype.handleApiError = function (error) {
        console.debug("Incoming API error", error);
        this.alert('Something went wrong. Give us a ring on 0800 463 996.');
    };
    RegistrationVue.prototype.alert = function (text) {
        this.$root['alert'](text);
    };
    RegistrationVue.prototype.navigate = function (page, query, options) {
        this.$router.push(__WEBPACK_IMPORTED_MODULE_2_lodash__["extend"]({}, { path: page, query: query }, options));
    };
    RegistrationVue.prototype.invalidateField = function (fieldName, message) {
        this.$validator.errorBag.add(fieldName, message, undefined);
    };
    RegistrationVue.prototype.doIfFormIsValid = function (callBack) {
        this.$validator.validateAll().then(function (valid) {
            if (valid) {
                callBack();
            }
        });
    };
    RegistrationVue = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], RegistrationVue);
    return RegistrationVue;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BodyCardTypeCardNumber */
/* unused harmony export BodyEmailPasswordBannerSourceApplication */
/* unused harmony export BodyBanner */
/* unused harmony export BodyPortalToken */
/* unused harmony export BodyRefreshTokenBanner */
/* unused harmony export BodyEmailPasswordNewPasswordBanner */
/* unused harmony export BodyEmailBanner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ClubCardUser; });
/* unused harmony export ClubCardUserResponse */
/* unused harmony export EmailSearch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EmailSearchResult; });
/* unused harmony export HybrisUser */
/* unused harmony export HybrisuserPhoneNumbers */
/* unused harmony export HybrisuserRoles */
/* unused harmony export InlineCodeMessage */
/* unused harmony export InlineError */
/* unused harmony export Search */
/* unused harmony export SearchResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SecurityQuestion; });
/* unused harmony export SecurityQuestions */
/* unused harmony export SetPasswordRequest */
/* unused harmony export SetPasswordResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Shopper; });
/* unused harmony export SubscriptionRequest */
/* unused harmony export SubscriptionResponse */
/* unused harmony export UserAuth */
/* unused harmony export UserRegisterResponse */
/* unused harmony export Validate */
/* unused harmony export ValidateUser */
/* unused harmony export UserApiServiceClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserApiService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var BodyCardTypeCardNumber = (function () {
    function BodyCardTypeCardNumber(partial) {
        Object.assign(this, partial);
    }
    return BodyCardTypeCardNumber;
}());

/**
* loginUser
*/
var BodyEmailPasswordBannerSourceApplication = (function () {
    function BodyEmailPasswordBannerSourceApplication(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailPasswordBannerSourceApplication;
}());

var BodyBanner = (function () {
    function BodyBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyBanner;
}());

var BodyPortalToken = (function () {
    function BodyPortalToken(partial) {
        Object.assign(this, partial);
    }
    return BodyPortalToken;
}());

var BodyRefreshTokenBanner = (function () {
    function BodyRefreshTokenBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyRefreshTokenBanner;
}());

var BodyEmailPasswordNewPasswordBanner = (function () {
    function BodyEmailPasswordNewPasswordBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailPasswordNewPasswordBanner;
}());

var BodyEmailBanner = (function () {
    function BodyEmailBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailBanner;
}());

var ClubCardUser = (function () {
    function ClubCardUser(partial) {
        Object.assign(this, partial);
    }
    return ClubCardUser;
}());

var ClubCardUserResponse = (function () {
    function ClubCardUserResponse(partial) {
        Object.assign(this, partial);
    }
    return ClubCardUserResponse;
}());

var EmailSearch = (function () {
    function EmailSearch(partial) {
        Object.assign(this, partial);
    }
    return EmailSearch;
}());

var EmailSearchResult = (function () {
    function EmailSearchResult(partial) {
        Object.assign(this, partial);
    }
    return EmailSearchResult;
}());

(function (EmailSearchResult) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["REGISTERED"] = 'REGISTERED'] = "REGISTERED";
        StatusEnum[StatusEnum["PARTIAL_REGISTERED"] = 'PARTIAL_REGISTERED'] = "PARTIAL_REGISTERED";
        StatusEnum[StatusEnum["NOT_REGISTERED"] = 'NOT_REGISTERED'] = "NOT_REGISTERED";
    })(StatusEnum = EmailSearchResult.StatusEnum || (EmailSearchResult.StatusEnum = {}));
})(EmailSearchResult || (EmailSearchResult = {}));
var HybrisUser = (function () {
    function HybrisUser(partial) {
        Object.assign(this, partial);
    }
    return HybrisUser;
}());

var HybrisuserPhoneNumbers = (function () {
    function HybrisuserPhoneNumbers(partial) {
        Object.assign(this, partial);
    }
    return HybrisuserPhoneNumbers;
}());

var HybrisuserRoles = (function () {
    function HybrisuserRoles(partial) {
        Object.assign(this, partial);
    }
    return HybrisuserRoles;
}());

var InlineCodeMessage = (function () {
    function InlineCodeMessage(partial) {
        Object.assign(this, partial);
    }
    return InlineCodeMessage;
}());

var InlineError = (function () {
    function InlineError(partial) {
        Object.assign(this, partial);
    }
    return InlineError;
}());

var Search = (function () {
    function Search(partial) {
        Object.assign(this, partial);
    }
    return Search;
}());

var SearchResult = (function () {
    function SearchResult(partial) {
        Object.assign(this, partial);
    }
    return SearchResult;
}());

(function (SearchResult) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["REGISTERED"] = 'REGISTERED'] = "REGISTERED";
        StatusEnum[StatusEnum["PARTIAL_REGISTERED"] = 'PARTIAL_REGISTERED'] = "PARTIAL_REGISTERED";
        StatusEnum[StatusEnum["NOT_REGISTERED"] = 'NOT_REGISTERED'] = "NOT_REGISTERED";
    })(StatusEnum = SearchResult.StatusEnum || (SearchResult.StatusEnum = {}));
})(SearchResult || (SearchResult = {}));
var SecurityQuestion = (function () {
    function SecurityQuestion(partial) {
        Object.assign(this, partial);
    }
    return SecurityQuestion;
}());

var SecurityQuestions = (function () {
    function SecurityQuestions(partial) {
        Object.assign(this, partial);
    }
    return SecurityQuestions;
}());

var SetPasswordRequest = (function () {
    function SetPasswordRequest(partial) {
        Object.assign(this, partial);
    }
    return SetPasswordRequest;
}());

var SetPasswordResponse = (function () {
    function SetPasswordResponse(partial) {
        Object.assign(this, partial);
    }
    return SetPasswordResponse;
}());

var Shopper = (function () {
    function Shopper(partial) {
        Object.assign(this, partial);
    }
    return Shopper;
}());

var SubscriptionRequest = (function () {
    function SubscriptionRequest(partial) {
        Object.assign(this, partial);
    }
    return SubscriptionRequest;
}());

var SubscriptionResponse = (function () {
    function SubscriptionResponse(partial) {
        Object.assign(this, partial);
    }
    return SubscriptionResponse;
}());

var UserAuth = (function () {
    function UserAuth(partial) {
        Object.assign(this, partial);
    }
    return UserAuth;
}());

var UserRegisterResponse = (function () {
    function UserRegisterResponse(partial) {
        Object.assign(this, partial);
    }
    return UserRegisterResponse;
}());

var Validate = (function () {
    function Validate(partial) {
        Object.assign(this, partial);
    }
    return Validate;
}());

var ValidateUser = (function () {
    function ValidateUser(partial) {
        Object.assign(this, partial);
    }
    return ValidateUser;
}());

var UserApiServiceClass = (function () {
    function UserApiServiceClass() {
        this.servicePath = '';
        this.basePath = '/user';
    }
    /**
    *
   */
    UserApiServiceClass.prototype.addLoyaltyCard = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/card';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'PUT'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.changePassword = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/password';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.completeRegistration = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/registration/complete';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.createSubscription = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/subscription';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.findUser = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/search';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.findUserByEmail = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/search/email';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.getProfile = function (authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.getSecurityQuestions = function (authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/security-questions/';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.login = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/login';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.loginAsGuest = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/login/guest';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.loginByPortalToken = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/login/portal';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.loginByRefreshToken = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/login/refresh';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.logout = function (authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/logout';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.registerUser = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.resetPassword = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/password/reset';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.setPassword = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/password/set';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.updateHybrisUser = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/hybris';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'PUT'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    UserApiServiceClass.prototype.validateUser = function (body, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/validate';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        _bodyData = body;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    return UserApiServiceClass;
}());

var UserApiService = new UserApiServiceClass();


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadSecurityQuestions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_generated_edge_user__ = __webpack_require__(8);

function loadSecurityQuestions(store) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0__services_generated_edge_user__["a" /* UserApiService */].getSecurityQuestions().then(function (response) {
            store.state.securityQuestions = response.securityQuestions;
            resolve();
        }).catch(function (error) {
            reject();
            _this.handleApiError(error);
        });
    });
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Address */
/* unused harmony export AutocompleteAddressCollection */
/* unused harmony export BasicAddress */
/* unused harmony export FaqItem */
/* unused harmony export InlineFaq */
/* unused harmony export Shopper */
/* unused harmony export AddressApiServiceClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressApiService; });
/* unused harmony export FaqApiServiceClass */
/* unused harmony export FaqApiService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var Address = (function () {
    function Address(partial) {
        Object.assign(this, partial);
    }
    return Address;
}());

var AutocompleteAddressCollection = (function () {
    function AutocompleteAddressCollection(partial) {
        Object.assign(this, partial);
    }
    return AutocompleteAddressCollection;
}());

var BasicAddress = (function () {
    function BasicAddress(partial) {
        Object.assign(this, partial);
    }
    return BasicAddress;
}());

var FaqItem = (function () {
    function FaqItem(partial) {
        Object.assign(this, partial);
    }
    return FaqItem;
}());

var InlineFaq = (function () {
    function InlineFaq(partial) {
        Object.assign(this, partial);
    }
    return InlineFaq;
}());

var Shopper = (function () {
    function Shopper(partial) {
        Object.assign(this, partial);
    }
    return Shopper;
}());

var AddressApiServiceClass = (function () {
    function AddressApiServiceClass() {
        this.servicePath = '';
        this.basePath = '/address';
    }
    /**
    *
   */
    AddressApiServiceClass.prototype.autocompleteAddress = function (address, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '';
        var _params = {};
        if (address !== undefined) {
            _params['address'] = address;
        }
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    /**
    *
   */
    AddressApiServiceClass.prototype.getAutocompleteAddressDetails = function (id, authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '/{id}'.replace('{' + 'id' + '}', String(id));
        var _params = {};
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    return AddressApiServiceClass;
}());

var AddressApiService = new AddressApiServiceClass();
var FaqApiServiceClass = (function () {
    function FaqApiServiceClass() {
        this.servicePath = '';
        this.basePath = '/faq';
    }
    /**
    *
   */
    FaqApiServiceClass.prototype.getFaqs = function (authToken) {
        var _this = this;
        var _localVarPath = this.servicePath + this.basePath + '';
        var _params = {};
        var _formParams = {};
        var _bodyData;
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || _this.authToken) ? { 'Authorization': 'Bearer ' + (authToken || _this.authToken) } : undefined
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    return FaqApiServiceClass;
}());

var FaqApiService = new FaqApiServiceClass();


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckboxComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_scss__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__checkbox_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CheckboxComponent = (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ripples = [];
        return _this;
    }
    CheckboxComponent.prototype.addRipple = function () {
        var _this = this;
        var ripple = document.createElement('div');
        ripple.className = 'ripple';
        if (!this.value) {
            ripple.className += ' red';
        }
        this.$refs.ripples.appendChild(ripple);
        setTimeout(function () { try {
            _this.$refs.ripples.removeChild(ripple);
        }
        catch (e) { } }, 1000);
    };
    CheckboxComponent.prototype.onChange = function (event) {
        this.$emit('input', event.target.checked);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], CheckboxComponent.prototype, "name", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], CheckboxComponent.prototype, "value", void 0);
    CheckboxComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<span>\n  <span ref=\"ripples\"></span>\n  <label class=\"checkbox-wrapper\">\n    <span class=\"checkbox-floating\">\n      <input class=\"checkbox\" @click=\"addRipple\" :checked=\"value\" @change=\"onChange\" type=\"checkbox\" :name=\"name\"/>\n      <span></span>\n    </span>\n    <slot></slot>\n  </label>\n</span>\n           "
        })
    ], CheckboxComponent);
    return CheckboxComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('checkbox', CheckboxComponent);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClubCardComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_scss__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__clubcard_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ClubCardComponent = (function (_super) {
    __extends(ClubCardComponent, _super);
    function ClubCardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"]
    ], ClubCardComponent.prototype, "zoom", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'newworld' })
    ], ClubCardComponent.prototype, "type", void 0);
    ClubCardComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"clubcard-real\" :class=\"type\">\n  <div class=\"clubcard-content\" :class=\"{ active: !zoom }\">\n    <template v-if=\"type == 'newworld'\">\n      <div class=\"clubcard-name\">YOUR NAME</div>\n      <div class=\"clubcard-number\">6014 3555 1234 5678</div>\n      <div class=\"clubcard-number-zoom\" v-if=\"zoom\">5678</div>\n    </template>\n  </div>\n</div>\n"
        })
    ], ClubCardComponent);
    return ClubCardComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('clubcard', ClubCardComponent);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputGroupComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var InputGroupComponent = (function (_super) {
    __extends(InputGroupComponent, _super);
    function InputGroupComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputGroupComponent.prototype, "valid", {
        get: function () {
            if (this.invalid === undefined) {
                if (this.err) {
                    return !this.err.has(this.name);
                }
                else {
                    return true;
                }
            }
            else {
                return !this.invalid;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], InputGroupComponent.prototype, "err", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: '' })
    ], InputGroupComponent.prototype, "name", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"]
    ], InputGroupComponent.prototype, "invalid", void 0);
    InputGroupComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"input-group\" :class=\"{ 'invalid': !valid }\">\n  <slot></slot>\n  <validation-error :error=\"!valid\">{{ err ? err.first(name) : '' }}</validation-error>\n</div>\n"
        })
    ], InputGroupComponent);
    return InputGroupComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('input-group', InputGroupComponent);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_scss__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__navbar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var NavbarComponent = (function (_super) {
    __extends(NavbarComponent, _super);
    function NavbarComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.step = 0;
        _this.backButtonVisible = true;
        _this.hideBack = true;
        _this.hideSteps = true;
        _this.hideBackInitial = true;
        _this.routesSequence = [];
        return _this;
    }
    NavbarComponent.prototype.mounted = function () {
        this.step = this.$route.meta.step;
        if (this.$route.path == '/') {
            this.hideBack = true;
            this.hideSteps = false;
            this.hideBackInitial = true;
        }
        else {
            this.hideBack = this.$route.meta.hideBack;
            this.hideSteps = this.$route.meta.hideSteps;
        }
    };
    NavbarComponent.prototype.routeChanged = function (to, from) {
        if (!(to.query.routerback)) {
            this.routesSequence.push(from);
        }
        this.step = to.meta.step;
        this.hideBack = to.meta.hideBack;
        this.hideSteps = to.meta.hideSteps;
        this.hideBackInitial = to.meta.hideBackInitial;
    };
    NavbarComponent.prototype.back = function () {
        var lastRoute;
        if (this.$route.meta.alwaysBackTo) {
            var index = __WEBPACK_IMPORTED_MODULE_3_lodash__["indexOf"](__WEBPACK_IMPORTED_MODULE_3_lodash__["map"](this.routesSequence, 'path'), this.$route.meta.alwaysBackTo);
            if (index !== -1) {
                lastRoute = this.routesSequence[index];
                this.routesSequence.length = index;
            }
        }
        else {
            lastRoute = this.routesSequence.pop();
        }
        if (lastRoute) {
            this.$router.push({ path: lastRoute.path, query: __WEBPACK_IMPORTED_MODULE_3_lodash__["extend"]({}, lastRoute.query, { routerback: 'true' }), params: lastRoute.params });
        }
        else {
            console.warn('Cannot go back: no route history, have you reloaded the browser? Going to email-entry');
            this.$router.push('email-entry');
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["watch"])('$route')
    ], NavbarComponent.prototype, "routeChanged", null);
    NavbarComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<nav class=\"navbar\">\n  <transition :name=\"hideBackInitial ? 'none' : 'fade'\">\n    <span v-if=\"!hideBack\" class=\"back-button\" @click=\"back\"></span>\n  </transition>\n  <transition name=\"fade\">\n    <span v-if=\"!hideSteps\"  class=\"steps\">Step {{ step }} of 3</span>\n  </transition>\n</nav>\n"
        })
    ], NavbarComponent);
    return NavbarComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));



/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadioComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radio_scss__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radio_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__radio_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var RadioComponent = (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ripples = [];
        return _this;
    }
    RadioComponent.prototype.addRipple = function () {
        var _this = this;
        var ripple = document.createElement('div');
        ripple.className = 'ripple';
        if (!this.value) {
            ripple.className += ' red';
        }
        this.$refs.ripples.appendChild(ripple);
        setTimeout(function () { try {
            _this.$refs.ripples.removeChild(ripple);
        }
        catch (e) { } }, 1000);
    };
    RadioComponent.prototype.onChange = function (event) {
        this.$emit('change', this.value);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], RadioComponent.prototype, "name", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], RadioComponent.prototype, "value", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Model"])('change'),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], RadioComponent.prototype, "currentValue", void 0);
    RadioComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<span>\n  <span ref=\"ripples\"></span>\n  <label class=\"radio-wrapper\">\n    <span class=\"radio-floating\">\n      <input class=\"radio\" @change=\"onChange\" ref=\"checkbox\" @click=\"addRipple\" type=\"radio\" :checked=\"currentValue === value\" :name=\"name\"/>\n      <span></span>\n    </span>\n    <slot></slot>\n  </label>\n</span>\n           "
        })
    ], RadioComponent);
    return RadioComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('radio', RadioComponent);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegistrationPageComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var RegistrationPageComponent = (function (_super) {
    __extends(RegistrationPageComponent, _super);
    function RegistrationPageComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], RegistrationPageComponent.prototype, "centered", void 0);
    RegistrationPageComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"page-container\">\n  <div class=\"form-container\" :class=\"{ 'centered': centered }\">\n    <template v-if=\"centered\">\n    <div class=\"content-centered\">\n      <div class=\"content-box\">\n        <slot></slot>\n      </div>\n    </div>\n    </template>\n    <template v-else><slot></slot></template>\n  </div>\n</div>\n"
        })
    ], RegistrationPageComponent);
    return RegistrationPageComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('registration-page', RegistrationPageComponent);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegistrationFormSubmitComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_form_submit_scss__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_form_submit_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__registration_form_submit_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var RegistrationFormSubmitComponent = (function (_super) {
    __extends(RegistrationFormSubmitComponent, _super);
    function RegistrationFormSubmitComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"]
    ], RegistrationFormSubmitComponent.prototype, "buttonLabel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"]
    ], RegistrationFormSubmitComponent.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"]
    ], RegistrationFormSubmitComponent.prototype, "disabled", void 0);
    RegistrationFormSubmitComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"button-center\">\n  <div class=\"button-container\">\n    <spinner class=\"absolute\" v-if=\"loading\"></spinner>\n    <button :disabled=\"disabled || loading\" class=\"button\" type=\"submit\"><slot></slot></button>\n  </div>\n</div>\n"
        })
    ], RegistrationFormSubmitComponent);
    return RegistrationFormSubmitComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('registration-form-submit', RegistrationFormSubmitComponent);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpinnerComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spin_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_scss__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__spinner_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var SpinnerComponent = (function (_super) {
    __extends(SpinnerComponent, _super);
    function SpinnerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerComponent.prototype.mounted = function () {
        var spinner = new __WEBPACK_IMPORTED_MODULE_2_spin_js___default.a({
            top: '12px',
            color: '#e01f32',
            speed: 1.2,
            width: 3,
            lines: 11,
            scale: 0.65
        }).spin(this.$refs['spin']);
    };
    SpinnerComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"spinner-container\">\n  <div ref=\"spin\"></div>\n</div>\n"
        })
    ], SpinnerComponent);
    return SpinnerComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('spinner', SpinnerComponent);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TooltipComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_scss__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tooltip_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var TooltipComponent = (function (_super) {
    __extends(TooltipComponent, _super);
    function TooltipComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<div class=\"tooltip top\">\n  <div class=\"tooltip--container\">\n    <div class=\"tooltip--text\">\n      <slot></slot>\n    </div>\n    <div class=\"tooltip--tip\"></div>\n  </div>\n</div>\n"
        })
    ], TooltipComponent);
    return TooltipComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tooltip', TooltipComponent);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpinnerComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var SpinnerComponent = (function (_super) {
    __extends(SpinnerComponent, _super);
    function SpinnerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            template: "\n<transition name=\"fade\">\n  <div class=\"validation-errors\" v-if=\"error\">\n    <slot></slot>\n  </div>\n</transition>\n",
            props: {
                error: Boolean
            }
        })
    ], SpinnerComponent);
    return SpinnerComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('validation-error', SpinnerComponent);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


//import { PhoneNumberUtil } from 'google-libphonenumber';
//const phoneUtil = PhoneNumberUtil.getInstance();
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('phone', {
    getMessage: function () { return 'We couldn\'t recognize that phone number format'; },
    validate: function (value) { return /^[0-9\+\(\)\s\-]*$/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('nzPhoneNumber', {
    getMessage: function () { return 'This phone number is not valid'; },
    validate: function (value) { return /((^((\+64|0)+(3|4|5|6|7|9))+\d{7}$)|(^((\+64|0)+(20|21|22|27|28|29))+\d{6,8}$))/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('nzMobileNumber', {
    getMessage: function () { return 'This mobile number is not valid'; },
    validate: function (value) { return /(^((\+64|0)+(20|21|22|27|28|29))+\d{6,8}$)/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('digitsonly', {
    getMessage: function () { return 'Clubcard number needs to be digits only'; },
    validate: function (value) { return /^[0-9]*$/.test(value.replace(/ /g, '')); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('cardstart', {
    getMessage: function () { return 'Clubcard number should start with 6014 3555'; },
    validate: function (value) { return value.replace(/ /g, '').startsWith('60143555'); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('letterMin', {
    getMessage: function () { return 'The password must have at least one letter'; },
    validate: function (value) { return /[a-zA-Z]/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('numberMin', {
    getMessage: function () { return 'The password must have at least one number'; },
    validate: function (value) { return /[0-9]/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('hybrisSpecialCharacters', {
    getMessage: function (field, params, data) {
        var uniqueCharacters = __WEBPACK_IMPORTED_MODULE_1_lodash__["uniq"](data);
        var plural = ' symbol is';
        if (uniqueCharacters.length > 1) {
            plural = ' symbols are';
        }
        return 'The ' + uniqueCharacters.join(', ') + plural + ' not allowed';
    },
    validate: function (value) { return ({
        valid: /^[\w!@$%^&*()_+=\-{};:'",.<>?|~`]+$/.test(value),
        data: Array.from(value.replace(/[\w!@$%^&*()_+=\-{};:'",.<>?|~`]/g, ''))
    }); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('firstNameLimitedCharacters', {
    getMessage: function () { return 'Sorry, your first name may only contain letters, spaces, hyphens and apostrophes. Please check and try again'; },
    validate: function (value) { return /^[a-zA-Z0-9\s-'’]*$/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('lastNameLimitedCharacters', {
    getMessage: function () { return 'Sorry, your last name may only contain letters, spaces, hyphens and apostrophes. Please check and try again'; },
    validate: function (value) { return /^[a-zA-Z0-9\s-'’]*$/.test(value); }
});
__WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"].extend('fsEmailExtention', {
    getMessage: function () { return 'That email doesn\'t look right'; },
    validate: function (value) { return !/^(\.|\"|.*\.{2,}|.*\.@)/.test(value); }
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_core__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_text_mask_core__);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('input-mask', {
    inserted: function (el, binding) {
        var textMaskInputElement = __WEBPACK_IMPORTED_MODULE_1_text_mask_core__["createTextMaskInputElement"]({
            inputElement: el,
            mask: binding.value,
            guide: false
        });
        el.addEventListener('input', function (event) {
            textMaskInputElement.update(event.target['value']);
        });
        el.addEventListener('blur', function (event) {
            textMaskInputElement.update(event.target['value']);
            var fakeEvent = document.createEvent("HTMLEvents");
            fakeEvent.initEvent("input", true, true);
            el.dispatchEvent(fakeEvent);
        });
    }
});


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__placeholder_title_scss__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__placeholder_title_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__placeholder_title_scss__);


var titleModeClass = 'title-mode';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('placeholder-title', {
    update: function (el, binding) {
        var selectMode = el.tagName.toLowerCase() === 'select';
        var placeholderTitle = el.parentNode.getElementsByClassName('placeholder-title')[0];
        placeholderTitle.innerText = binding.value;
        if (document.activeElement !== el) {
            if (el.value !== '') {
                placeholderTitle.className = el.dataset.defaultClass + ' ' + titleModeClass;
            }
            else {
                placeholderTitle.className = el.dataset.defaultClass;
            }
        }
    },
    inserted: function (el, binding) {
        var selectMode = el.tagName.toLowerCase() === 'select';
        var placeholderTitle = document.createElement('div');
        el.dataset.defaultClass = 'placeholder-title' + (selectMode ? ' select-mode' : '');
        if (el.className.indexOf('icon') === -1) {
            el.dataset.defaultClass += ' no-icon';
        }
        setTimeout(function () {
            el.dataset.defaultClass += ' animate';
            placeholderTitle.style.display = 'block';
            //placeholderTitle.style.top = ((<HTMLElement>el).clientHeight/2) - (placeholderTitle.clientHeight/2) + 1 + 'px';
        }, 1);
        placeholderTitle.className = el.dataset.defaultClass;
        placeholderTitle.innerText = el.getAttribute('placeholder') || binding.value;
        el.parentNode.insertBefore(placeholderTitle, el);
        el.setAttribute('placeholder', '');
        placeholderTitle.addEventListener("click", function () {
            el.focus();
        });
        if (!selectMode && !el.getAttribute('placeholder-no-focus')) {
            el.addEventListener("focus", function () {
                placeholderTitle.className = el.dataset.defaultClass + ' ' + titleModeClass;
            });
            el.addEventListener("blur", function () {
                if (el.value === '') {
                    placeholderTitle.className = el.dataset.defaultClass;
                }
            });
        }
        else {
            el.addEventListener("change", function () {
                placeholderTitle.className = el.dataset.defaultClass + ' ' + titleModeClass;
            });
        }
    }
});


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_forms_email_entry_email_entry__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_forms_clubcard_verify_clubcard_verify__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_forms_security_entry_security_entry__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_forms_clubcard_has_question_clubcard_has_question__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_forms_clubcard_entry_clubcard_entry__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_messages_email_registered_email_registered__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_messages_registration_error_registration_error__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_forms_clubcard_choose_reward_clubcard_choose_reward__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_forms_clubcard_details_entry_clubcard_details_entry__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_forms_address_entry_address_entry__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_forms_fresh_registration_fresh_registration__ = __webpack_require__(273);













var routes = [
    //step 1
    { path: '/email-entry', component: __WEBPACK_IMPORTED_MODULE_2__pages_forms_email_entry_email_entry__["a" /* EmailEntryPage */], meta: { step: 1, hideBackInitial: true, hideBack: true } },
    //step 2
    { path: '/clubcard-verify', component: __WEBPACK_IMPORTED_MODULE_3__pages_forms_clubcard_verify_clubcard_verify__["a" /* ClubCardVerifyPage */], meta: { step: 2 } },
    { path: '/clubcard-has-question', component: __WEBPACK_IMPORTED_MODULE_5__pages_forms_clubcard_has_question_clubcard_has_question__["a" /* ClubCardHasQuestionPage */], meta: { step: 2 } },
    { path: '/clubcard-entry', component: __WEBPACK_IMPORTED_MODULE_6__pages_forms_clubcard_entry_clubcard_entry__["a" /* ClubCardEntryPage */], meta: { step: 2 } },
    //clubcard/clubcard-choose-reward
    { path: '/clubcard-choose-reward', component: __WEBPACK_IMPORTED_MODULE_9__pages_forms_clubcard_choose_reward_clubcard_choose_reward__["a" /* ClubCardChooseRewardPage */], meta: { step: 2 } },
    { path: '/clubcard-details-entry', component: __WEBPACK_IMPORTED_MODULE_10__pages_forms_clubcard_details_entry_clubcard_details_entry__["a" /* ClubCardDetailsEntryPage */], meta: { step: 2, alwaysBackTo: '/clubcard-choose-reward' } },
    { path: '/address-entry', component: __WEBPACK_IMPORTED_MODULE_11__pages_forms_address_entry_address_entry__["a" /* AddressEntryPage */], meta: { step: 2, hideSteps: true } },
    // step 3 - fresh mailing list
    { path: '/fresh-registration', component: __WEBPACK_IMPORTED_MODULE_12__pages_forms_fresh_registration_fresh_registration__["a" /* FreshRegistrationPage */], meta: { step: 3 } },
    // step 3
    { path: '/security-entry', component: __WEBPACK_IMPORTED_MODULE_4__pages_forms_security_entry_security_entry__["a" /* SecurityEntryPage */], meta: { step: 3 } },
    { path: '/email-registered', component: __WEBPACK_IMPORTED_MODULE_7__pages_messages_email_registered_email_registered__["a" /* EmailRegisteredPage */], meta: { step: 1, hideSteps: true } },
    { path: '/registration-error', component: __WEBPACK_IMPORTED_MODULE_8__pages_messages_registration_error_registration_error__["a" /* RegistrationErrorPage */], meta: { step: 1, hideSteps: true } },
];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({ routes: routes, mode:  false ? undefined : 'abstract' });


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(279);


var initialState = {
    email: '',
    firstName: '',
    formFirstName: '',
    lastName: '',
    formLastName: '',
    phoneNumber: '',
    password: '',
    securityQuestion: '',
    securityAnswer: '',
    presetPhoneNumber: '',
    clubcardNumber: '',
    isQuickShopper: false,
    isFullShopper: false,
    agreeTerms: false,
    agreeComms: true,
    flybuysNumber: '',
    airpointsNumber: '',
    rewardType: 'none',
    flybuysOption: 'none',
    airpointsOption: 'none',
    title: '',
    gender: '',
    dateOfBirth: '',
    securityQuestions: [],
    resAddress: {
        isManual: false,
        address: '',
        pxid: '',
        manualAddress: {
            unit: '',
            streetNumber: '',
            streetName: '',
            deliveryServiceNumber: '',
            ruralDeliveryNumber: '',
            suburb: '',
            city: '',
            postcode: ''
        }
    },
    samePostalAddress: true,
    postAddress: {
        isManual: false,
        address: '',
        pxid: '',
        manualAddress: {
            unit: '',
            streetNumber: '',
            streetName: '',
            deliveryServiceNumber: '',
            ruralDeliveryNumber: '',
            suburb: '',
            city: '',
            postcode: ''
        }
    },
    scrolls: {},
    autologinParams: '',
    requireTitle: false
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: initialState,
    mutations: {
        reset: function (state) {
            for (var key in state) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, key, initialState[key]);
            }
        }
    },
    getters: {
        firstName: function (state) {
            return state.firstName || '';
        },
        hasFirstName: function (state) {
            return !!state.firstName;
        },
        hasLastName: function (state) {
            return !!state.lastName;
        }
    }
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dictionary; });
var dictionary = {
    firstName: {
        required: 'Please enter your first name'
    },
    lastName: {
        required: 'Please enter your last name'
    }
};


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, exports) {

module.exports = "<registration-page class=address-entry> <form @submit.prevent=submitManualAddress novalidate> <transition name=fade-one-way> <div v-if=!manualInput> <div class=form-heading> <p>Please start typing your {{type == 'res' ? 'Residential' : 'Postal'}} Address in the field below.</p> </div> <input-group :err=errors name=address class=address-input> <div class=\"content-centered spinner-wrapper\"> <spinner class=spinner v-if=addressLoading></spinner> </div> <input ref=addressInput class=\"input input-icon\" :class=\"type == 'res' ? 'icon-home' : 'icon-pobox'\" name=address @input=onAddressInput v-no-auto-complete type=text v-placeholder-title=\"type == 'res' ? 'Residential address' : 'Postal address'\"/> </input-group> <transition name=fade-one-way> <div class=no-address v-if=\"autoCompleteAddresses.length == 0 && !addressLoading && address.length >= 3\"> <div class=text-center> <p>We couldn't find that address</p> <p><button class=button type=button @click=enterManualInput()>Enter Manually</button></p> </div> </div> </transition> <transition name=fade-one-way> <div class=addresses-list v-if=\"autoCompleteAddresses.length > 0\"> <div v-for=\"address of autoCompleteAddresses\" @click=selectAddress(address) class=address-item>{{address.description}}</div> </div> </transition> </div> </transition> <transition name=fade-one-way> <div v-if=manualInput> <div class=form-heading> <p>Please enter your {{type == 'res' ? 'Residential' : 'Postal'}} Address in fields provided below or <a href=# @click.prevent=enterAutoInput()>go&nbsp;back&nbsp;to&nbsp;the&nbsp;address&nbsp;finder</a>.</p> </div> <input-group :err=errors name=streetName> <input class=input name=streetName v-validate=\"'required'\" v-model=manualAddress.streetName v-no-auto-complete type=text v-placeholder-title=\"'Street name'\"/> </input-group> <div class=\"split-input-groups content-centered\"> <input-group :err=errors name=streetNumber> <input class=input name=streetNumber v-model=manualAddress.streetNumber v-validate=\"'required'\" v-no-auto-complete type=text v-placeholder-title=\"'Street number'\"/> </input-group> <input-group :err=errors name=postcode> <input class=input v-model=manualAddress.postcode name=postcode v-validate=\"'required|digitsonly'\" v-no-auto-complete type=tel v-placeholder-title=\"'Postcode'\"/> </input-group> </div> <input-group :err=errors name=city> <input class=input name=city v-model=manualAddress.city v-validate=\"'required'\" v-no-auto-complete type=text v-placeholder-title=\"'Town'\"/> </input-group> <div class=form-heading> <p>Optional address information</p> </div> <input-group :err=errors name=unit> <input class=input name=unit v-model=manualAddress.unit v-no-auto-complete type=text v-placeholder-title=\"'Unit'\"/> </input-group> <input-group :err=errors name=suburb> <input class=input name=suburb v-model=manualAddress.suburb v-no-auto-complete type=text v-placeholder-title=\"'Suburb'\"/> </input-group> <input-group :err=errors name=ruralDeliveryNumber> <input class=input name=ruralDeliveryNumber v-model=manualAddress.ruralDeliveryNumber v-no-auto-complete type=text v-placeholder-title=\"'Rural delivery number'\"/> </input-group> <registration-form-submit :disabled=\"!manualAddress.streetName || !manualAddress.postcode || !manualAddress.streetNumber || !manualAddress.city\">Done</registration-form-submit> </div> </transition> </form> </registration-page> ";

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next novalidate> <div class=form-heading> <p>Lets set up New World Clubcard for you, it will take only a minute.</p> <p>Would you like to collect Fly Buys points or earn Airpoints Dollars™ as a reward? <a class=nowrap href=#>Learn about both options</a></p> </div> <input-group class=input-checkbox> <radio name=rewardType v-model=$store.state.rewardType value=flybuys> Fly Buys Points</radio> </input-group> <input-group class=input-checkbox> <radio name=rewardType v-model=$store.state.rewardType value=airpoints> Airpoints Dollars</radio> </input-group> <transition name=fade-slide-x2> <div v-if=\"$store.state.rewardType !== 'none'\"> <template v-if=\"$store.state.rewardType === 'flybuys'\"> <p>Are you already a member of Fly Buys?</p> <input-group class=input-checkbox> <radio name=flybuysOption v-model=$store.state.flybuysOption value=member key=flybuys>Yes</radio> </input-group> <input-group class=input-checkbox> <radio name=flybuysOption v-model=$store.state.flybuysOption value=join key=flybuys>No, I wish to become a member</radio> </input-group> </template> <template v-else> <p>Are you already a member of Airpoints™?</p> <input-group class=input-checkbox> <radio name=airpointsOption v-model=$store.state.airpointsOption value=member key=airpoints>Yes</radio> </input-group> <input-group class=input-checkbox> <radio name=airpointsOption v-model=$store.state.airpointsOption value=join key=airpoints>No, I wish to become a member</radio> </input-group> </template> </div> </transition> <transition name=fade-slide-x2> <div v-if=\"$store.state.airpointsOption !== 'none' || $store.state.flybuysOption !== 'none'\"> <template v-if=\"$store.state.rewardType === 'flybuys' && $store.state.flybuysOption === 'member'\"> <clubcard type=flybuys></clubcard> <p>Enter your Fly Buys number, you can find it on either the front or back of your Fly Buys card.</p> <input-group :err=errors name=flybuysnumber> <input v-validate=\"'required|digitsonly|min:19'\" key=flybuys data-vv-validate-on=blur type=tel class=\"input input-icon icon-card\" pattern=[0-9]* data-vv-name=flybuysnumber v-no-auto-complete v-model=$store.state.flybuysNumber inputmode=numeric v-input-mask=\"[/\\d/, /\\d/, /\\d/, /\\d/, ' ',/\\d/, /\\d/, /\\d/, /\\d/, ' ', /\\d/, /\\d/, /\\d/, /\\d/, ' ', /\\d/, /\\d/, /\\d/, /\\d/]\" v-placeholder-title=\"'Fly Buys number'\" maxlength=19 /> </input-group> </template> <template v-if=\"$store.state.rewardType === 'airpoints' && $store.state.airpointsOption === 'member'\"> <clubcard type=airpoints></clubcard> <p>Please, Enter your Airpoints number, you can find this on the front of your Airpoints card.</p> <input-group :err=errors name=airpointsnumber key=airpoints> <input v-validate=\"'required|digitsonly|min:8'\" data-vv-validate-on=blur type=tel class=\"input input-icon icon-card\" pattern=[0-9]* data-vv-name=airpointsnumber v-no-auto-complete v-model=$store.state.airpointsNumber inputmode=numeric v-input-mask=\"[/\\d/, /\\d/, /\\d/, /\\d/, /\\d/, /\\d/, /\\d/, /\\d/]\" v-placeholder-title=\"'Airpoints number'\" maxlength=8 /> </input-group> </template> </div> </transition> <transition name=fade-slide-x2> <template v-if=\"$store.state.rewardType !== 'none' && ( $store.state.flybuysOption !== 'none' || $store.state.airpointsOption !== 'none') \"> <div> <p class=terms-note v-if=\"$store.state.rewardType =='flybuys' && $store.state.flybuysOption == 'join'\"> By continuing you agree Fly Buys <a href=https://www.flybuys.co.nz/Pages/site/terms_and_conditions target=_blank>Terms and Conditions</a>. </p> <p class=terms-note v-if=\"$store.state.rewardType =='airpoints' && $store.state.airpointsOption == 'join'\"> By continuing you agree <a href=https://www.airnewzealand.co.nz/airpoints-terms-and-conditions target=_blank>Airpoints Terms and Conditions</a>, Air New Zealand <a href=http://www.airnewzealand.co.nz/privacy-policy target=_blank>Privacy Policy</a> and <a target=_blank href=https://www.airnewzealand.co.nz/website-terms-of-use>Website and Mobile App Terms of Use.</a> </p> <registration-form-submit :disabled=\"( $store.state.rewardType === 'flybuys' && $store.state.flybuysOption === 'member' && $store.state.flybuysNumber.length === 0 ) || ( $store.state.rewardType === 'airpoints' && $store.state.airpointsOption === 'member' && $store.state.airpointsNumber.length === 0 ) \" :style=\"{ 'transition-delay': ($store.state.flybuysOption === 'member' || $store.state.airpointsOption === 'member') ? '.4s' : '0' }\">Continue</registration-form-submit> </div> </template> </transition> <div ref=pageBottom></div> <transition name=fade-slide-x2> <template v-if=\"$store.state.rewardType == 'none' || ( $store.state.flybuysOption == 'none' && $store.state.airpointsOption == 'none') \"> <div class=\"join-later text-center\"> <button type=button class=\"button inverted\" @click=setupLater>Setup Later</button> </div> </template> </transition> </form> </registration-page> ";

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next novalidate> <div class=form-heading> <p>Please fill in your details.</p> <div class=title-selector :class=\"{ 'enable-gender' : $store.state.title == 'dr' }\"> <input-group class=input-select> <select v-placeholder-title=\"'Title'\" class=\"input input-icon icon-user\" name=title v-model=$store.state.title v-validate=\"'required'\"> <option value=\"\" disabled=disabled>Select Title...</option> <option value=miss>Miss</option> <option value=ms>Ms</option> <option value=mrs>Mrs</option> <option value=mr>Mr</option> <option value=dr>Dr</option> </select> </input-group> <div class=\"gender-selector content-centered\"> <div class=\"placeholder-title title-mode\">Gender</div> <input-group> <radio name=gender v-model=$store.state.gender value=female>Female</radio> </input-group> <input-group> <radio name=gender v-model=$store.state.gender value=male>Male</radio> </input-group> </div> </div> <input-group :err=errors name=firstName> <input class=\"input input-icon icon-user\" v-model=$store.state.firstName name=firstName data-vv-as=\"First Name\" v-no-auto-complete type=text v-placeholder-title=\"'First name'\" v-validate=\"'required|firstNameLimitedCharacters|max:40'\"/> </input-group> <input-group :err=errors name=lastName> <input class=\"input input-icon icon-user\" v-model=$store.state.lastName name=lastName data-vv-as=\"Last Name\" v-no-auto-complete type=text v-placeholder-title=\"'Last name'\" v-validate=\"'required|lastNameLimitedCharacters|max:40'\"/> </input-group> <input-group :err=errors name=dateOfBirth> <transition name=fade-slide-top> <tooltip v-if=dateOfBirthFocused> <span>We'll use your date of birth to verify your {{ $store.state.rewardType == 'flybuys' ? 'Fly Buys' : 'Airpoints™' }} membership and in the future your Clubcard membership.</span><br/> <span><b>Format: DD/MM/YYYY e.g. 19/03/1970</b></span> </tooltip> </transition> <input v-input-mask=\"[/\\d/, /\\d/, '/', /\\d/, /\\d/, '/', /\\d/, /\\d/, /\\d/, /\\d/]\" class=\"input input-icon icon-calendar\" v-model=$store.state.dateOfBirth name=dateOfBirth v-placeholder-title=\"'Date Of Birth'\" v-no-auto-complete @focus=\"dateOfBirthFocused = true\" data-vv-name=dateOfBirth v-validate=\"'required|date_format:DD/MM/YYYY'\" @blur=\"dateOfBirthFocused = false\" type=tel /> </input-group> <input-group :err=errors name=resAddress> <div class=overlay-click @click=onResAddressClick></div> <input class=\"input input-icon icon-home\" :value=resAddress name=resAddress @focus=onResAddressFocus ref=resField placeholder-no-focus=true v-no-auto-complete type=text v-placeholder-title=\"'Residential address'\"/> </input-group> <input-group class=input-checkbox> <checkbox v-model=$store.state.samePostalAddress name=samePostalAddress>Postal address is the same as resedential </checkbox> </input-group> <transition name=fade-slide> <input-group :err=errors name=resAddress v-if=!$store.state.samePostalAddress> <div class=overlay-click @click=onPostAddressClick></div> <input class=\"input input-icon icon-pobox\" @focus=onPostAddressFocus name=postAddress ref=postField :value=postAddress placeholder-no-focus=true v-no-auto-complete type=text v-placeholder-title=\"'Postal address'\" v-validate=\"'required'\"/> </input-group> </transition> <registration-form-submit :loading=loading :disabled=submitDisabled>Continue</registration-form-submit> </div> </form> </registration-page> ";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next novalidate id=clubCardEntryForm> <div class=form-heading> <clubcard></clubcard> <p>Please enter your your Clubcard details as they appear on the card.</p> </div> <input-group :err=errors name=name> <input v-model=name class=\"input input-icon icon-user qa-name\" name=name type=text v-placeholder-title=\"'Cardholder name'\" v-no-auto-complete v-validate=\"'required'\"/> </input-group> <input-group :err=errors name=ccnumber> <input v-validate=\"'required|digitsonly|min:19|cardstart'\" data-vv-validate-on=blur type=tel class=\"input input-icon icon-card qa-ccnumber\" pattern=[0-9]* data-vv-name=ccnumber v-no-auto-complete v-model=$store.state.clubcardNumber inputmode=numeric v-input-mask=\"[/\\d/, /\\d/, /\\d/, /\\d/, ' ',/\\d/, /\\d/, /\\d/, /\\d/, ' ', /\\d/, /\\d/, /\\d/, /\\d/, ' ', /\\d/, /\\d/, /\\d/, /\\d/]\" v-placeholder-title=\"'Clubcard Number'\" maxlength=19 /> </input-group> <registration-form-submit class=qa-continue-button :disabled=\"$store.state.clubcardNumber.length == 0 || name.length == 0\" :loading=loading>Continue </registration-form-submit> </form> </registration-page> ";

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <div class=form-heading> <clubcard zoom=true></clubcard> <p class=text-center>Link your New&nbsp;World&nbsp;Clubcard to your I shop New&nbsp;World account for savings and rewards.</p> <p class=text-center>Enter the <b>last four digits</b> on your card.</p> </div> <form @submit.prevent=next novalidate> <input-group> <div class=clubcard-last-digits> <input class=input type=tel inputmode=numeric v-input-mask=\"[/\\d/, /\\d/, /\\d/, /\\d/]\" pattern=[0-9]* data-vv-name=validationNumber v-no-auto-complete v-model=$store.state.clubcardNumber required minlength=4 maxlength=4 /> </div> </input-group> <registration-form-submit class=qa-continue-button :loading=loading :disabled=\"$store.state.clubcardNumber.length < 4 || loading\"> Continue </registration-form-submit> <div class=clubcard-help>If you don't have your Clubcard<br/>give us a ring on 0800 463 996. </div> </form> </registration-page> ";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next novalidate id=emailEntryForm> <div class=form-heading> <p>Sign up to I shop New World to start shopping.</p> <p>Just enter your email address.</p> </div> <input-group :err=errors name=email> <input v-placeholder-title=\"'Email'\" v-model=$store.state.email class=\"input input-icon icon-email qa-email-input\" name=email v-no-auto-complete type=email v-validate=\"'required|email|fsEmailExtention'\"/> </input-group> <registration-form-submit class=qa-continue-button :loading=loading :disabled=\"$store.state.email.length == 0 || loading\">Continue </registration-form-submit> </form> </registration-page> ";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next id=freshRegistration> <div class=form-heading> <h1>Hi {{ $store.getters.firstName }}</h1> <p>Please fill in your details to complete your sign up. It's best to give us your mobile number so you can receive SMS alerts on your order.</p> </div> <input-group :err=errors name=firstName v-if=!$store.getters.hasFirstName> <input v-placeholder-title=\"'First Name'\" ref=firstName class=\"input input-icon icon-user qa-firstName\" v-model=$store.state.formFirstName name=firstName v-no-auto-complete type=text data-vv-as=\"First Name\" v-validate=\"'required|firstNameLimitedCharacters|max:40'\"/> </input-group> <input-group :err=errors name=lastName v-if=!$store.getters.hasLastName> <input v-placeholder-title=\"'Last Name'\" ref=lastName class=\"input input-icon icon-user qa-lastName\" v-model=$store.state.formLastName name=lastName v-no-auto-complete type=text data-vv-as=\"Last Name\" v-validate=\"'required|lastNameLimitedCharacters|max:40'\"/> </input-group> <input-group :err=errors name=mobileNumber> <input v-placeholder-title=\"'Mobile Number'\" ref=mobileNumber class=\"input input-icon icon-phone qa-mobileNumber\" maxlength=13 v-model=$store.state.mobileNumber name=mobileNumber v-no-auto-complete type=tel v-validate=\"'nzMobileNumber'\"/> </input-group> <input-group :invalid=\"errors.has('password') && !passwordFocused\" name=password :err=errors> <input v-placeholder-title=\"'Password'\" class=\"input input-icon icon-password qa-password\" v-validate=\"'required|min:6|max:20|letterMin|numberMin'\" v-no-auto-complete @input=\"$validator.validate('password', $refs.passwordField.value)\" ref=passwordField required type=password @focus.prevent=\"passwordFocused = true;\" @blur=\"passwordFocused = false\" name=password /> <span class=show-password-button @mousedown.prevent=toggleShowPassword()></span> <div class=password-help-tooltip :class=\"{ 'all-valid': fields.password && fields.password.valid }\"> <transition name=fade-slide-top> <tooltip v-if=\"passwordFocused && fields.password && !fields.password.valid\"> <div class=heading>Password needs to</div> <ul class=requirements> <li :class=\"{ met: $refs.passwordField.value.length >= 6 && $refs.passwordField.value.length <= 20 }\">be between 6 and 20 characters</li> <li :class=\"{ met: /[a-zA-Z]/.test($refs.passwordField.value) }\">include at least one letter</li> <li :class=\"{ met: /\\d/.test($refs.passwordField.value) }\">include at least one number</li> </ul> </tooltip> </transition> </div> </input-group> <input-group class=input-checkbox> <checkbox v-model=$store.state.agreeComms name=comms>I would like to receive New World<br/>promotional emails</checkbox> </input-group> <input-group :err=errors name=agree class=input-checkbox> <checkbox class=qa-terms-agree v-model=$store.state.agree name=agree @change=\"$validator.validate('agree', $event.target.checked);\" v-validate=\"'required'\"> I agree to the I shop New World<br/> <a href=\"http://www.newworld.co.nz/online-shopping-info/terms-and-conditions/?faq=true\" target=_blank> Terms and Conditions</a> and <a href=\"http://www.newworld.co.nz/online-shopping-info/privacy/?faq=true\" target=_blank>Privacy Policy</a> </checkbox> </input-group> <registration-form-submit class=qa-sign-up :disabled=\"($refs.passwordField && $refs.passwordField.value.length == 0)\" :loading=loading>Sign up </registration-form-submit> </form> </registration-page> ";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<registration-page> <form @submit.prevent=next id=securityEntryForm> <div class=form-heading> <template v-if=\"!$store.state.isQuickShopper && !$store.state.isFullShopper\"> <h1>Hi {{ $store.state.firstName }}</h1> </template> <p>Please fill in your details to complete your sign up. It's best to give us your mobile number so you can receive SMS alerts on your order.</p> </div> <template v-if=$store.state.isQuickShopper> <input-group :err=errors name=firstName id=firstNameInputGroup> <input v-placeholder-title=\"'First Name'\" class=\"input input-icon icon-user qa-firstName\" v-model=$store.state.firstName v-no-auto-complete type=text name=firstName data-vv-as=\"First Name\" v-validate=\"'required|firstNameLimitedCharacters|max:40'\"/> </input-group> <input-group :err=errors name=lastName id=lastNameInputGroup> <input v-placeholder-title=\"'Last Name'\" class=\"input input-icon icon-user qa-lastName\" v-model=$store.state.lastName v-no-auto-complete type=text name=lastName data-vv-as=\"Last Name\" v-validate=\"'required|lastNameLimitedCharacters|max:40'\"/> </input-group> </template> <input-group :err=errors name=phoneNumber> <input v-placeholder-title=\"'Phone Number'\" ref=phone class=\"input input-icon icon-phone qa-phoneNumber\" maxlength=13 v-model=$store.state.phoneNumber name=phoneNumber v-no-auto-complete type=tel v-validate=\"'required|phone|nzPhoneNumber'\"/> </input-group> <template v-if=$store.state.requireTitle> <input-group class=input-select :err=errors name=title> <select v-placeholder-title=\"'Title'\" ref=title class=\"input input-icon icon-user qa-title-dropdown\" v-model=$store.state.title name=title v-validate=\"$store.state.requireTitle ? 'required': ''\"> <option value=\"\" disabled=disabled>Select a title...</option> <option value=mr>Mr</option> <option value=ms>Ms</option> <option value=miss>Miss</option> <option value=mrs>Mrs</option> <option value=dr>Dr</option> </select> </input-group> </template> <input-group :invalid=\"errors.has('password') && !passwordFocused\" name=password :err=errors> <input v-placeholder-title=\"'Password'\" class=\"input input-icon icon-password qa-password\" v-validate=\"'required|min:6|max:20|letterMin|numberMin|hybrisSpecialCharacters'\" v-no-auto-complete @input=\"$validator.validate('password', $refs.passwordField.value)\" ref=passwordField required type=password @focus.prevent=\"passwordFocused = true;\" @blur=\"passwordFocused = false\" name=password /> <span class=show-password-button @mousedown.prevent=toggleShowPassword()></span> <div class=password-help-tooltip :class=\"{ 'all-valid': fields.password && fields.password.valid }\"> <transition name=fade-slide-top> <tooltip v-if=\"passwordFocused && fields.password && !fields.password.valid\"> <div class=heading>Password needs to</div> <ul class=requirements> <li :class=\"{ met: $refs.passwordField.value.length >= 6 && $refs.passwordField.value.length <= 20 }\">be between 6 and 20 characters</li> <li :class=\"{ met: /[a-zA-Z]/.test($refs.passwordField.value) }\">include at least one letter</li> <li :class=\"{ met: /\\d/.test($refs.passwordField.value) }\">include at least one number</li> <li :class=\"{ met: /^[\\w!@$%^&*()_+=\\-{};:'\\x22,.<>?|~`]+$/.test($refs.passwordField.value) }\">must only contain allowed characters</li> </ul> </tooltip> </transition> </div> </input-group> <template v-if=!$store.state.isQuickShopper> <input-group class=input-select> <select class=\"input input-icon icon-question qa-question-dropdown\" name=question v-model=$store.state.securityQuestion v-validate=\"'required'\"> <option value=\"\" disabled=disabled>Select a question...</option> <option v-for=\"(option, index) of $store.state.securityQuestions\" :value=index>{{option.text}}</option> </select> </input-group> <input-group :err=errors name=answer> <input class=\"input input-icon icon-answer qa-answer-input\" type=text name=answer v-model=$store.state.securityAnswer v-no-auto-complete v-placeholder-title=\"'Answer'\" v-validate=\"'required'\" minlength=0 /> </input-group> </template> <input-group class=input-checkbox> <checkbox v-model=$store.state.agreeComms name=comms>I would like to receive New World<br/>promotional emails</checkbox> </input-group> <input-group :err=errors name=agree class=input-checkbox> <checkbox class=qa-terms-agree v-model=$store.state.agree name=agree @change=\"$validator.validate('agree', $event.target.checked);\" v-validate=\"'required'\"> I agree to the I shop New World<br/> <a href=\"http://www.newworld.co.nz/online-shopping-info/terms-and-conditions/?faq=true\" target=_blank>Terms and Conditions</a> and <a href=\"http://www.newworld.co.nz/online-shopping-info/privacy/?faq=true\" target=_blank>Privacy Policy</a>{{ $store.state.isFullShopper ? ',' : '' }} <span v-if=$store.state.isFullShopper> New&nbsp;World&nbsp;Clubcard <a href=https://www.clubcard.co.nz/newworld/en/clubterms target=_blank>Terms and Conditions</a> </span> </checkbox> </input-group> <registration-form-submit class=qa-create-account :disabled=\"($refs.passwordField && $refs.passwordField.value.length == 0) || (!$store.state.isQuickShopper && ($store.state.securityAnswer.length == 0 || $store.state.securityQuestion.length == 0)) || ($store.state.isQuickShopper && ($store.state.firstName.length == 0 || $store.state.lastName.length == 0))\" :loading=loading>Sign up </registration-form-submit> </form> </registration-page> ";

/***/ }),
/* 259 */,
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 52,
	"./af.js": 52,
	"./ar": 59,
	"./ar-dz": 53,
	"./ar-dz.js": 53,
	"./ar-kw": 54,
	"./ar-kw.js": 54,
	"./ar-ly": 55,
	"./ar-ly.js": 55,
	"./ar-ma": 56,
	"./ar-ma.js": 56,
	"./ar-sa": 57,
	"./ar-sa.js": 57,
	"./ar-tn": 58,
	"./ar-tn.js": 58,
	"./ar.js": 59,
	"./az": 60,
	"./az.js": 60,
	"./be": 61,
	"./be.js": 61,
	"./bg": 62,
	"./bg.js": 62,
	"./bn": 63,
	"./bn.js": 63,
	"./bo": 64,
	"./bo.js": 64,
	"./br": 65,
	"./br.js": 65,
	"./bs": 66,
	"./bs.js": 66,
	"./ca": 67,
	"./ca.js": 67,
	"./cs": 68,
	"./cs.js": 68,
	"./cv": 69,
	"./cv.js": 69,
	"./cy": 70,
	"./cy.js": 70,
	"./da": 71,
	"./da.js": 71,
	"./de": 74,
	"./de-at": 72,
	"./de-at.js": 72,
	"./de-ch": 73,
	"./de-ch.js": 73,
	"./de.js": 74,
	"./dv": 75,
	"./dv.js": 75,
	"./el": 76,
	"./el.js": 76,
	"./en-au": 77,
	"./en-au.js": 77,
	"./en-ca": 78,
	"./en-ca.js": 78,
	"./en-gb": 79,
	"./en-gb.js": 79,
	"./en-ie": 80,
	"./en-ie.js": 80,
	"./en-nz": 81,
	"./en-nz.js": 81,
	"./eo": 82,
	"./eo.js": 82,
	"./es": 84,
	"./es-do": 83,
	"./es-do.js": 83,
	"./es.js": 84,
	"./et": 85,
	"./et.js": 85,
	"./eu": 86,
	"./eu.js": 86,
	"./fa": 87,
	"./fa.js": 87,
	"./fi": 88,
	"./fi.js": 88,
	"./fo": 89,
	"./fo.js": 89,
	"./fr": 92,
	"./fr-ca": 90,
	"./fr-ca.js": 90,
	"./fr-ch": 91,
	"./fr-ch.js": 91,
	"./fr.js": 92,
	"./fy": 93,
	"./fy.js": 93,
	"./gd": 94,
	"./gd.js": 94,
	"./gl": 95,
	"./gl.js": 95,
	"./gom-latn": 96,
	"./gom-latn.js": 96,
	"./he": 97,
	"./he.js": 97,
	"./hi": 98,
	"./hi.js": 98,
	"./hr": 99,
	"./hr.js": 99,
	"./hu": 100,
	"./hu.js": 100,
	"./hy-am": 101,
	"./hy-am.js": 101,
	"./id": 102,
	"./id.js": 102,
	"./is": 103,
	"./is.js": 103,
	"./it": 104,
	"./it.js": 104,
	"./ja": 105,
	"./ja.js": 105,
	"./jv": 106,
	"./jv.js": 106,
	"./ka": 107,
	"./ka.js": 107,
	"./kk": 108,
	"./kk.js": 108,
	"./km": 109,
	"./km.js": 109,
	"./kn": 110,
	"./kn.js": 110,
	"./ko": 111,
	"./ko.js": 111,
	"./ky": 112,
	"./ky.js": 112,
	"./lb": 113,
	"./lb.js": 113,
	"./lo": 114,
	"./lo.js": 114,
	"./lt": 115,
	"./lt.js": 115,
	"./lv": 116,
	"./lv.js": 116,
	"./me": 117,
	"./me.js": 117,
	"./mi": 118,
	"./mi.js": 118,
	"./mk": 119,
	"./mk.js": 119,
	"./ml": 120,
	"./ml.js": 120,
	"./mr": 121,
	"./mr.js": 121,
	"./ms": 123,
	"./ms-my": 122,
	"./ms-my.js": 122,
	"./ms.js": 123,
	"./my": 124,
	"./my.js": 124,
	"./nb": 125,
	"./nb.js": 125,
	"./ne": 126,
	"./ne.js": 126,
	"./nl": 128,
	"./nl-be": 127,
	"./nl-be.js": 127,
	"./nl.js": 128,
	"./nn": 129,
	"./nn.js": 129,
	"./pa-in": 130,
	"./pa-in.js": 130,
	"./pl": 131,
	"./pl.js": 131,
	"./pt": 133,
	"./pt-br": 132,
	"./pt-br.js": 132,
	"./pt.js": 133,
	"./ro": 134,
	"./ro.js": 134,
	"./ru": 135,
	"./ru.js": 135,
	"./sd": 136,
	"./sd.js": 136,
	"./se": 137,
	"./se.js": 137,
	"./si": 138,
	"./si.js": 138,
	"./sk": 139,
	"./sk.js": 139,
	"./sl": 140,
	"./sl.js": 140,
	"./sq": 141,
	"./sq.js": 141,
	"./sr": 143,
	"./sr-cyrl": 142,
	"./sr-cyrl.js": 142,
	"./sr.js": 143,
	"./ss": 144,
	"./ss.js": 144,
	"./sv": 145,
	"./sv.js": 145,
	"./sw": 146,
	"./sw.js": 146,
	"./ta": 147,
	"./ta.js": 147,
	"./te": 148,
	"./te.js": 148,
	"./tet": 149,
	"./tet.js": 149,
	"./th": 150,
	"./th.js": 150,
	"./tl-ph": 151,
	"./tl-ph.js": 151,
	"./tlh": 152,
	"./tlh.js": 152,
	"./tr": 153,
	"./tr.js": 153,
	"./tzl": 154,
	"./tzl.js": 154,
	"./tzm": 156,
	"./tzm-latn": 155,
	"./tzm-latn.js": 155,
	"./tzm.js": 156,
	"./uk": 157,
	"./uk.js": 157,
	"./ur": 158,
	"./ur.js": 158,
	"./uz": 160,
	"./uz-latn": 159,
	"./uz-latn.js": 159,
	"./uz.js": 160,
	"./vi": 161,
	"./vi.js": 161,
	"./x-pseudo": 162,
	"./x-pseudo.js": 162,
	"./yo": 163,
	"./yo.js": 163,
	"./zh-cn": 164,
	"./zh-cn.js": 164,
	"./zh-hk": 165,
	"./zh-hk.js": 165,
	"./zh-tw": 166,
	"./zh-tw.js": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BodyCardTypeCardNumber */
/* unused harmony export BodyEmailPasswordBannerSourceApplication */
/* unused harmony export BodyBanner */
/* unused harmony export BodyPortalToken */
/* unused harmony export BodyRefreshTokenBanner */
/* unused harmony export BodyEmailPasswordNewPasswordBanner */
/* unused harmony export BodyEmailBanner */
/* unused harmony export ClubCardUser */
/* unused harmony export ClubCardUserResponse */
/* unused harmony export EmailSearch */
/* unused harmony export EmailSearchResult */
/* unused harmony export HybrisUser */
/* unused harmony export HybrisuserPhoneNumbers */
/* unused harmony export HybrisuserRoles */
/* unused harmony export InlineCodeMessage */
/* unused harmony export InlineError */
/* unused harmony export Search */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResult; });
/* unused harmony export SecurityQuestion */
/* unused harmony export SecurityQuestions */
/* unused harmony export SetPasswordRequest */
/* unused harmony export SetPasswordResponse */
/* unused harmony export Shopper */
/* unused harmony export SubscriptionRequest */
/* unused harmony export SubscriptionResponse */
/* unused harmony export UserAuth */
/* unused harmony export UserRegisterResponse */
/* unused harmony export Validate */
/* unused harmony export ValidateUser */
/* unused harmony export UserApiMockSetup */
var BodyCardTypeCardNumber = (function () {
    function BodyCardTypeCardNumber(partial) {
        Object.assign(this, partial);
    }
    return BodyCardTypeCardNumber;
}());

/**
* }
*/
var BodyEmailPasswordBannerSourceApplication = (function () {
    function BodyEmailPasswordBannerSourceApplication(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailPasswordBannerSourceApplication;
}());

var BodyBanner = (function () {
    function BodyBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyBanner;
}());

var BodyPortalToken = (function () {
    function BodyPortalToken(partial) {
        Object.assign(this, partial);
    }
    return BodyPortalToken;
}());

var BodyRefreshTokenBanner = (function () {
    function BodyRefreshTokenBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyRefreshTokenBanner;
}());

var BodyEmailPasswordNewPasswordBanner = (function () {
    function BodyEmailPasswordNewPasswordBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailPasswordNewPasswordBanner;
}());

var BodyEmailBanner = (function () {
    function BodyEmailBanner(partial) {
        Object.assign(this, partial);
    }
    return BodyEmailBanner;
}());

var ClubCardUser = (function () {
    function ClubCardUser(partial) {
        Object.assign(this, partial);
    }
    return ClubCardUser;
}());

var ClubCardUserResponse = (function () {
    function ClubCardUserResponse(partial) {
        Object.assign(this, partial);
    }
    return ClubCardUserResponse;
}());

var EmailSearch = (function () {
    function EmailSearch(partial) {
        Object.assign(this, partial);
    }
    return EmailSearch;
}());

var EmailSearchResult = (function () {
    function EmailSearchResult(partial) {
        Object.assign(this, partial);
    }
    return EmailSearchResult;
}());

(function (EmailSearchResult) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["REGISTERED"] = 'REGISTERED'] = "REGISTERED";
        StatusEnum[StatusEnum["PARTIAL_REGISTERED"] = 'PARTIAL_REGISTERED'] = "PARTIAL_REGISTERED";
        StatusEnum[StatusEnum["NOT_REGISTERED"] = 'NOT_REGISTERED'] = "NOT_REGISTERED";
    })(StatusEnum = EmailSearchResult.StatusEnum || (EmailSearchResult.StatusEnum = {}));
})(EmailSearchResult || (EmailSearchResult = {}));
var HybrisUser = (function () {
    function HybrisUser(partial) {
        Object.assign(this, partial);
    }
    return HybrisUser;
}());

var HybrisuserPhoneNumbers = (function () {
    function HybrisuserPhoneNumbers(partial) {
        Object.assign(this, partial);
    }
    return HybrisuserPhoneNumbers;
}());

var HybrisuserRoles = (function () {
    function HybrisuserRoles(partial) {
        Object.assign(this, partial);
    }
    return HybrisuserRoles;
}());

var InlineCodeMessage = (function () {
    function InlineCodeMessage(partial) {
        Object.assign(this, partial);
    }
    return InlineCodeMessage;
}());

var InlineError = (function () {
    function InlineError(partial) {
        Object.assign(this, partial);
    }
    return InlineError;
}());

var Search = (function () {
    function Search(partial) {
        Object.assign(this, partial);
    }
    return Search;
}());

var SearchResult = (function () {
    function SearchResult(partial) {
        Object.assign(this, partial);
    }
    return SearchResult;
}());

(function (SearchResult) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["REGISTERED"] = 'REGISTERED'] = "REGISTERED";
        StatusEnum[StatusEnum["PARTIAL_REGISTERED"] = 'PARTIAL_REGISTERED'] = "PARTIAL_REGISTERED";
        StatusEnum[StatusEnum["NOT_REGISTERED"] = 'NOT_REGISTERED'] = "NOT_REGISTERED";
    })(StatusEnum = SearchResult.StatusEnum || (SearchResult.StatusEnum = {}));
})(SearchResult || (SearchResult = {}));
var SecurityQuestion = (function () {
    function SecurityQuestion(partial) {
        Object.assign(this, partial);
    }
    return SecurityQuestion;
}());

var SecurityQuestions = (function () {
    function SecurityQuestions(partial) {
        Object.assign(this, partial);
    }
    return SecurityQuestions;
}());

var SetPasswordRequest = (function () {
    function SetPasswordRequest(partial) {
        Object.assign(this, partial);
    }
    return SetPasswordRequest;
}());

var SetPasswordResponse = (function () {
    function SetPasswordResponse(partial) {
        Object.assign(this, partial);
    }
    return SetPasswordResponse;
}());

var Shopper = (function () {
    function Shopper(partial) {
        Object.assign(this, partial);
    }
    return Shopper;
}());

var SubscriptionRequest = (function () {
    function SubscriptionRequest(partial) {
        Object.assign(this, partial);
    }
    return SubscriptionRequest;
}());

var SubscriptionResponse = (function () {
    function SubscriptionResponse(partial) {
        Object.assign(this, partial);
    }
    return SubscriptionResponse;
}());

var UserAuth = (function () {
    function UserAuth(partial) {
        Object.assign(this, partial);
    }
    return UserAuth;
}());

var UserRegisterResponse = (function () {
    function UserRegisterResponse(partial) {
        Object.assign(this, partial);
    }
    return UserRegisterResponse;
}());

var Validate = (function () {
    function Validate(partial) {
        Object.assign(this, partial);
    }
    return Validate;
}());

var ValidateUser = (function () {
    function ValidateUser(partial) {
        Object.assign(this, partial);
    }
    return ValidateUser;
}());

function UserApiMockSetup(expressApp, controller) {
    expressApp['PUT'.toLowerCase()]('/user/card'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request PUT /user/card');
        if (!controller['addLoyaltyCard']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['addLoyaltyCard'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/password'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/password');
        if (!controller['changePassword']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['changePassword'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/registration/complete'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/registration/complete');
        if (!controller['completeRegistration']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['completeRegistration'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/subscription'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/subscription');
        if (!controller['createSubscription']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['createSubscription'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/search'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/search');
        if (!controller['findUser']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['findUser'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/search/email'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/search/email');
        if (!controller['findUserByEmail']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['findUserByEmail'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['GET'.toLowerCase()]('/user'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        console.log('receiving request GET /user');
        if (!controller['getProfile']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['getProfile'](undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['GET'.toLowerCase()]('/user/security-questions/'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        console.log('receiving request GET /user/security-questions/');
        if (!controller['getSecurityQuestions']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['getSecurityQuestions'](undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/login'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/login');
        if (!controller['login']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['login'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/login/guest'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/login/guest');
        if (!controller['loginAsGuest']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['loginAsGuest'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/login/portal'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/login/portal');
        if (!controller['loginByPortalToken']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['loginByPortalToken'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/login/refresh'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/login/refresh');
        if (!controller['loginByRefreshToken']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['loginByRefreshToken'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/logout'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        console.log('receiving request POST /user/logout');
        if (!controller['logout']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['logout'](undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user');
        if (!controller['registerUser']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['registerUser'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/password/reset'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/password/reset');
        if (!controller['resetPassword']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['resetPassword'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/password/set'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/password/set');
        if (!controller['setPassword']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['setPassword'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['PUT'.toLowerCase()]('/user/hybris'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request PUT /user/hybris');
        if (!controller['updateHybrisUser']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['updateHybrisUser'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
    expressApp['POST'.toLowerCase()]('/user/validate'.replace(/{(.*?)}/g, ':$1'), function (req, res, next) {
        var body = req.body;
        console.log('receiving request POST /user/validate');
        if (!controller['validateUser']) {
            res.status(500).send('Not implemented');
        }
        else {
            controller['validateUser'](body, undefined)
                .then(function (result) {
                res.status(200).json(result);
                next();
            }).catch(function (error) {
                res.status(500).send('Internal server error');
            });
        }
    });
}


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_navbar_navbar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_registation_page_registration_page__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_spinner_spinner__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_validation_error_validation_error__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_registration_form_submit_registration_form_submit__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_input_group_input_group__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_clubcard_clubcard__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tooltip_tooltip__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_checkbox_checkbox__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_radio_radio__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_placeholder_title_placeholder_title__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__directives_input_mask_input_mask__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__custom_validators__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_generated_edge_info__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__validation_dictionary__ = __webpack_require__(184);

__WEBPACK_IMPORTED_MODULE_0_es6_promise__["polyfill"]();

/*import * as FastClick from './vendor/fastclick.js';
 FastClick['attach'](document.body);*/























__WEBPACK_IMPORTED_MODULE_5_vee_validate__["Validator"].installDateTimeValidators(__WEBPACK_IMPORTED_MODULE_1_moment__);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate___default.a, {
    events: 'blur',
    enableAutoClasses: true,
    dictionary: {
        en: {
            custom: __WEBPACK_IMPORTED_MODULE_23__validation_dictionary__["a" /* dictionary */]
        }
    }
});
if (EDGE_URL !== '{{ edgeUrl }}') {
    __WEBPACK_IMPORTED_MODULE_21__services_generated_edge_user__["a" /* UserApiService */].servicePath = EDGE_URL;
    __WEBPACK_IMPORTED_MODULE_22__services_generated_edge_info__["a" /* AddressApiService */].servicePath = 'https://api-int.dev.fsniwaikato.kiwi/v1/edge';
}
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('no-auto-complete', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.setAttribute('autocomplete', 'off');
        el.setAttribute('autocorrect', 'off');
        el.setAttribute('autocapitalize', 'off');
        el.setAttribute('spellcheck', 'false');
    }
});
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app-main',
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* router */],
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
    data: {
        transitionName: 'slide-left'
    },
    components: {
        'navbar': __WEBPACK_IMPORTED_MODULE_8__components_navbar_navbar__["a" /* NavbarComponent */],
        Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
    },
    mounted: function () {
        if (this.$router.currentRoute.path == '/') {
            this.$router.push('email-entry');
        }
    },
    methods: {
        alert: function (text) {
            this.$refs.simplert.openSimplert({
                message: text,
                customCloseBtnClass: 'inverted'
            });
        }
    },
    watch: {
        '$route': function (to, from) {
            if (to.path == '/address-entry') {
                this.$data['transitionName'] = 'slide-address';
            }
            else if (from.path == '/address-entry') {
                this.$data['transitionName'] = 'slide-address-back';
            }
            else if (from.path == '/') {
                this.$data['transitionName'] = 'none';
            }
            else {
                this.$data['transitionName'] = __WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"](__WEBPACK_IMPORTED_MODULE_7__router__["b" /* routes */], { path: to.path }) > __WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"](__WEBPACK_IMPORTED_MODULE_7__router__["b" /* routes */], { path: from.path }) ? 'slide-left' : 'slide-right';
            }
            var el = document.getElementsByClassName('page-container')[0];
            if (el) {
                el.style.top = '-' + window.scrollY + 'px';
            }
        }
    }
});


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressEntryPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__address_entry_scss__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__address_entry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__address_entry_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_generated_edge_info__ = __webpack_require__(35);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var AddressEntryPage = (function (_super) {
    __extends(AddressEntryPage, _super);
    function AddressEntryPage() {
        var _this = _super.call(this) || this;
        _this.address = '';
        _this.type = '';
        _this.manualInput = false;
        _this.addressLoading = false;
        _this.autoCompleteAddresses = [];
        _this.manualAddress = {
            unit: '',
            streetNumber: '',
            streetName: '',
            deliveryServiceNumber: '',
            ruralDeliveryNumber: '',
            suburb: '',
            city: '',
            postcode: ''
        };
        _this.onAddressInput = __WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"](function (e) {
            _this.address = e.target.value;
            _this.autoCompleteAddress(e.target.value);
        }, 300);
        return _this;
    }
    AddressEntryPage.prototype.autoCompleteAddress = function (address) {
        var _this = this;
        this.address = address;
        if (this.address.length >= 3) {
            this.addressLoading = true;
            __WEBPACK_IMPORTED_MODULE_4__services_generated_edge_info__["a" /* AddressApiService */].autocompleteAddress(this.address).then(function (addressCollection) {
                _this.addressLoading = false;
                _this.autoCompleteAddresses = addressCollection.addresses;
            }).catch(function () {
                _this.addressLoading = false;
            });
        }
    };
    AddressEntryPage.prototype.selectAddress = function (address) {
        this.addressStateModel.address = address.description;
        this.addressStateModel.pxid = address.id;
        this.addressStateModel.isManual = false;
        this.addressStateModel.manualAddress = {};
        this.navigate('clubcard-details-entry', { returnFromAddressEntry: 'true' });
    };
    AddressEntryPage.prototype.enterManualInput = function () {
        this.manualInput = true;
    };
    AddressEntryPage.prototype.enterAutoInput = function () {
        this.address = '';
        this.manualInput = false;
    };
    AddressEntryPage.prototype.created = function () {
        this.$validator.updateDictionary({
            en: {
                custom: {
                    streetName: {
                        required: 'Please enter your street name'
                    },
                    streetNumber: {
                        required: 'Street number is required'
                    },
                    town: {
                        required: 'Please enter your town'
                    },
                    postcode: {
                        required: 'Please enter your postcode',
                        digitsonly: 'Postcode needs to be digits only'
                    }
                }
            }
        });
    };
    AddressEntryPage.prototype.mounted = function () {
        this.type = this.$route.query.type;
        if (this.addressStateModel.isManual) {
            this.manualInput = true;
            this.manualAddress = __WEBPACK_IMPORTED_MODULE_3_lodash__["clone"](this.addressStateModel.manualAddress);
        }
        else {
            var addressInput_1 = this.$refs.addressInput;
            var initialValue = this.addressStateModel.address;
            if (addressInput_1) {
                addressInput_1.value = initialValue;
                setTimeout(function () {
                    addressInput_1.focus();
                }, 500);
            }
        }
    };
    Object.defineProperty(AddressEntryPage.prototype, "addressStateModel", {
        get: function () {
            return this.$store.state[this.type + 'Address'];
        },
        enumerable: true,
        configurable: true
    });
    AddressEntryPage.prototype.submitManualAddress = function () {
        var _this = this;
        if (this.manualInput) {
            this.doIfFormIsValid(function () {
                _this.addressStateModel.address = '';
                _this.addressStateModel.pxid = '';
                _this.addressStateModel.isManual = true;
                _this.addressStateModel.manualAddress = __WEBPACK_IMPORTED_MODULE_3_lodash__["clone"](_this.manualAddress);
                _this.navigate('clubcard-details-entry', { returnFromAddressEntry: 'true' });
            });
        }
    };
    AddressEntryPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(251) })
    ], AddressEntryPage);
    return AddressEntryPage;
}(__WEBPACK_IMPORTED_MODULE_1__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubCardChooseRewardPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_choose_reward_scss__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_choose_reward_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__clubcard_choose_reward_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_smooth_scroll_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_smooth_scroll_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vendor_smooth_scroll_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_property_decorator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var ClubCardChooseRewardPage = (function (_super) {
    __extends(ClubCardChooseRewardPage, _super);
    function ClubCardChooseRewardPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClubCardChooseRewardPage.prototype.mounted = function () {
        this.$validator.updateDictionary({
            en: {
                custom: {
                    airpointsnumber: {
                        required: 'Please enter your Airpoints number',
                        min: 'Airpoints number should be 8 digits',
                        digitsonly: 'Airpoints number needs to be digits only'
                    },
                    flybuysnumber: {
                        required: 'Please enter your Fly Buys number',
                        min: 'Fly Buys number should be 16 digits',
                        digitsonly: 'Fly Buys number needs to be digits only'
                    }
                }
            }
        });
    };
    ClubCardChooseRewardPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.navigate('clubcard-details-entry');
        });
    };
    ClubCardChooseRewardPage.prototype.setupLater = function () {
        this.$store.state.isQuickShopper = true;
        this.navigate('security-entry');
    };
    ClubCardChooseRewardPage.prototype.onMembershipChanged = function (newValue) {
        var _this = this;
        console.log('watch happened');
        if (newValue == 'member') {
            setTimeout(function () {
                console.log('animate scroll');
                console.log(__WEBPACK_IMPORTED_MODULE_3__vendor_smooth_scroll_js__["animateScroll"]);
                __WEBPACK_IMPORTED_MODULE_3__vendor_smooth_scroll_js__["animateScroll"](_this.$refs.pageBottom, undefined, { speed: 300, easing: 'easeOutCubic' });
            }, 50);
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue_property_decorator__["Watch"])('$store.state.flybuysOption'),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue_property_decorator__["Watch"])('$store.state.airpointsOption')
    ], ClubCardChooseRewardPage.prototype, "onMembershipChanged", null);
    ClubCardChooseRewardPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(252) })
    ], ClubCardChooseRewardPage);
    return ClubCardChooseRewardPage;
}(__WEBPACK_IMPORTED_MODULE_1__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubCardDetailsEntryPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_details_entry_scss__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clubcard_details_entry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__clubcard_details_entry_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ClubCardDetailsEntryPage = (function (_super) {
    __extends(ClubCardDetailsEntryPage, _super);
    function ClubCardDetailsEntryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dateOfBirthFocused = false;
        _this.loading = false;
        return _this;
    }
    ClubCardDetailsEntryPage.prototype.mounted = function () {
        this.$validator.updateDictionary({
            en: {
                custom: {
                    dateOfBirth: {
                        required: 'Please enter your date of birth',
                        date_format: 'Date of birth should be in the format DD/MM/YYYY'
                    }
                }
            }
        });
    };
    ClubCardDetailsEntryPage.prototype.onResAddressClick = function () {
        this.navigate('address-entry', { type: 'res' });
    };
    ClubCardDetailsEntryPage.prototype.onPostAddressClick = function () {
        this.navigate('address-entry', { type: 'post' });
    };
    ClubCardDetailsEntryPage.prototype.onPostAddressFocus = function () {
        this.$refs.postField.blur();
        this.onPostAddressClick();
    };
    ClubCardDetailsEntryPage.prototype.onResAddressFocus = function () {
        this.$refs.resField.blur();
        this.onResAddressClick();
    };
    Object.defineProperty(ClubCardDetailsEntryPage.prototype, "resAddress", {
        get: function () {
            return this.formatAddress(this.$store.state.resAddress);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClubCardDetailsEntryPage.prototype, "postAddress", {
        get: function () {
            return this.formatAddress(this.$store.state.postAddress);
        },
        enumerable: true,
        configurable: true
    });
    ClubCardDetailsEntryPage.prototype.formatAddress = function (addressStateModel) {
        if (!addressStateModel.isManual) {
            return addressStateModel.address;
        }
        else {
            var formattedAddress = '';
            if (addressStateModel.manualAddress.ruralDeliveryNumber) {
                formattedAddress += addressStateModel.manualAddress.ruralDeliveryNumber + ', ';
            }
            if (addressStateModel.manualAddress.unit) {
                formattedAddress += addressStateModel.manualAddress.unit + ' ';
            }
            formattedAddress += addressStateModel.manualAddress.streetNumber + ' ' + addressStateModel.manualAddress.streetName + ', ';
            if (addressStateModel.manualAddress.suburb) {
                formattedAddress += addressStateModel.manualAddress.suburb + ', ';
            }
            formattedAddress += addressStateModel.manualAddress.city + ' ' + addressStateModel.manualAddress.postcode;
            return formattedAddress;
        }
    };
    Object.defineProperty(ClubCardDetailsEntryPage.prototype, "submitDisabled", {
        get: function () {
            return !this.$store.state.firstName.length ||
                !this.$store.state.lastName ||
                !this.$store.state.dateOfBirth ||
                !this.$store.state.title ||
                this.$store.state.title == 'dr' && !this.$store.state.gender ||
                !this.resAddress ||
                !this.$store.state.samePostalAddress && !this.postAddress;
        },
        enumerable: true,
        configurable: true
    });
    ClubCardDetailsEntryPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.loading = true;
            _this.$store.state.isFullShopper = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* loadSecurityQuestions */])(_this.$store).then(function () {
                _this.navigate('security-entry');
            }).catch(function () {
                _this.loading = false;
            });
        });
    };
    ClubCardDetailsEntryPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(253) })
    ], ClubCardDetailsEntryPage);
    return ClubCardDetailsEntryPage;
}(__WEBPACK_IMPORTED_MODULE_1__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubCardEntryPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mock_api_edge_user_index__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var StatusEnum = __WEBPACK_IMPORTED_MODULE_3__mock_api_edge_user_index__["a" /* SearchResult */].StatusEnum;

var ClubCardEntryPage = (function (_super) {
    __extends(ClubCardEntryPage, _super);
    function ClubCardEntryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.name = '';
        return _this;
    }
    ClubCardEntryPage.prototype.mounted = function () {
        this.$store.state.clubcardNumber = '';
        this.$validator.updateDictionary({
            en: {
                custom: {
                    ccnumber: {
                        required: 'Please enter your Clubcard number',
                        min: 'Clubcard number should be 16 digits',
                    },
                    name: {
                        required: 'Please enter your name as it appears on the card'
                    }
                }
            }
        });
        dataLayer.push({
            'event': 'stepLoaded',
            'stepNumber': '2',
            'stepName': 'Enter clubcard details'
        });
    };
    ClubCardEntryPage.prototype.created = function () {
        this.$validator.extend('berror', {
            getMessage: function (field, params, data) {
                return (data && data.message) || 'Something went wrong';
            },
            validate: function (value) {
                return {
                    valid: false,
                    data: {
                        message: value
                    }
                };
            }
        });
    };
    ClubCardEntryPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].findUser({
                email: _this.$store.state.email,
                clubCard: _this.$store.state.clubcardNumber.replace(/ /g, ''),
                name: _this.name,
                banner: ''
            }).then(function (searchResult) {
                switch (searchResult.status) {
                    case StatusEnum.REGISTERED:
                        _this.navigate('registration-error');
                        break;
                    case StatusEnum.PARTIAL_REGISTERED:
                        _this.$store.state.isQuickShopper = false;
                        _this.$store.state.firstName = searchResult.fistName;
                        _this.$store.state.lastName = searchResult.lastName;
                        _this.$store.state.presetPhoneNumber = searchResult.phoneNumber;
                        _this.$store.state.requireTitle = searchResult.requireTitle;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* loadSecurityQuestions */])(_this.$store).then(function () {
                            _this.navigate('security-entry');
                        }).catch(function () {
                            _this.loading = false;
                        });
                        break;
                    case StatusEnum.NOT_REGISTERED:
                        _this.loading = false;
                        _this.alert('We can\'t find your Clubcard. Please check the information you\'ve entered and try again. Or give us a ring on 0800 463 996.');
                        break;
                    default:
                        _this.loading = false;
                        _this.handleApiError("Unknown status: " + searchResult.status);
                        break;
                }
            }).catch(function (error) {
                _this.loading = false;
                _this.handleApiError(error);
            });
        });
    };
    ClubCardEntryPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(254) })
    ], ClubCardEntryPage);
    return ClubCardEntryPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubCardHasQuestionPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clubcard_has_question_scss__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clubcard_has_question_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clubcard_has_question_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ClubCardHasQuestionPage = (function (_super) {
    __extends(ClubCardHasQuestionPage, _super);
    function ClubCardHasQuestionPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fullRegistrationEnabled = false;
        return _this;
    }
    ClubCardHasQuestionPage.prototype.mounted = function () {
        this.$store.state.firstName = '';
        this.$store.state.lastName = '';
        this.$store.state.phoneNumber = '';
        dataLayer.push({
            'event': 'stepLoaded',
            'stepNumber': '2',
            'stepName': 'Do you have a club card'
        });
    };
    ClubCardHasQuestionPage.prototype.yes = function () {
        this.$store.state.isQuickShopper = false;
        memberStatus = true;
        dataLayer.push({
            'event': 'clubcardStatus',
            'clubCard': 'yes'
        });
        this.navigate('clubcard-entry');
    };
    ClubCardHasQuestionPage.prototype.no = function () {
        memberStatus = false;
        dataLayer.push({
            'event': 'clubCardStatus',
            'clubCard': 'no'
        });
        if (this.fullRegistrationEnabled) {
            this.navigate('clubcard-choose-reward');
        }
        else {
            this.$store.state.isQuickShopper = true;
            this.navigate('security-entry');
        }
    };
    ClubCardHasQuestionPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({
            template: "\n<registration-page centered=\"true\" class=\"has-question\">\n  <h1>Do you have a New World Clubcard?</h1>\n  <button @click=\"no\" class=\"button inverted qa-no-button\">No</button>\n  <button @click=\"yes\" class=\"button inverted qa-yes-button\">Yes</button>\n</registration-page>\n"
        })
    ], ClubCardHasQuestionPage);
    return ClubCardHasQuestionPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubCardVerifyPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clubcard_verify_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clubcard_verify_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__clubcard_verify_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var ClubCardVerifyPage = (function (_super) {
    __extends(ClubCardVerifyPage, _super);
    function ClubCardVerifyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    ClubCardVerifyPage.prototype.mounted = function () {
        this.$store.state.clubcardNumber = '';
    };
    ClubCardVerifyPage.prototype.next = function () {
        var _this = this;
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].validateUser({
            email: this.$store.state.email,
            cardNumber: this.$store.state.clubcardNumber.replace(/ /g, ''),
            banner: ''
        }).then(function (validateResult) {
            if (!validateResult.valid) {
                _this.loading = false;
                _this.alert('The last four digits you\'ve provided do not match - please try again.');
            }
            else {
                _this.$store.state.firstName = validateResult.firstName;
                _this.$store.state.lastName = validateResult.lastName;
                _this.$store.state.presetPhoneNumber = validateResult.phoneNumber;
                _this.$store.state.requireTitle = validateResult.requireTitle;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* loadSecurityQuestions */])(_this.$store).then(function () {
                    _this.navigate('security-entry');
                }).catch(function () {
                    _this.loading = false;
                });
            }
        }).catch(function (error) {
            _this.loading = false;
            if (error.response.data.message == 'Validate failed') {
                _this.alert('The last four digits you\'ve provided do not match - please try again.');
            }
            else {
                _this.handleApiError(error);
            }
        });
    };
    ClubCardVerifyPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(255) })
    ], ClubCardVerifyPage);
    return ClubCardVerifyPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailEntryPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email_entry_scss__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email_entry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__email_entry_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var StatusEnum = __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["e" /* EmailSearchResult */].StatusEnum;


var EmailEntryPage = (function (_super) {
    __extends(EmailEntryPage, _super);
    function EmailEntryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    EmailEntryPage.prototype.mounted = function () {
        dataLayer.push({
            'event': 'stepLoaded',
            'stepNumber': '1',
            'stepName': 'Enter email address'
        });
        this.$validator.updateDictionary({
            en: {
                custom: {
                    email: {
                        required: 'Please enter your email address',
                        email: 'That email doesn\'t look right'
                    }
                }
            }
        });
    };
    EmailEntryPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].findUserByEmail({
                email: _this.$store.state.email,
                banner: ''
            }).then(function (searchResult) {
                _this.$store.state.firstName = searchResult.firstName;
                _this.$store.state.lastName = searchResult.lastName;
                switch (searchResult.status) {
                    case StatusEnum.REGISTERED:
                        _this.navigate('email-registered');
                        break;
                    case StatusEnum.PARTIAL_REGISTERED:
                        _this.$store.state.isQuickShopper = false;
                        // club card takes priority over fresh mailer list
                        if (searchResult.roles.includes('ZNW001')) {
                            _this.navigate('clubcard-verify');
                            break;
                        }
                        else if (searchResult.roles.includes('ZNW002')) {
                            // fresh mailing list role
                            _this.navigate('fresh-registration');
                            break;
                        }
                        else {
                            // partially registered users with neither role still go to fresh registration page
                            _this.navigate('fresh-registration');
                            break;
                        }
                    case StatusEnum.NOT_REGISTERED:
                        _this.navigate('clubcard-has-question');
                        break;
                    default:
                        _this.loading = false;
                        _this.handleApiError("Unknown status: " + searchResult.status);
                        break;
                }
            }).catch(function (error) {
                _this.loading = false;
                _this.handleApiError(error);
            });
        });
    };
    EmailEntryPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(256) })
    ], EmailEntryPage);
    return EmailEntryPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FreshRegistrationPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fresh_registration_scss__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fresh_registration_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fresh_registration_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var FreshRegistrationPage = (function (_super) {
    __extends(FreshRegistrationPage, _super);
    function FreshRegistrationPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.passwordFocused = false;
        _this.loading = false;
        return _this;
    }
    FreshRegistrationPage.prototype.mounted = function () {
        dataLayer.push({
            'event': 'stepLoaded',
            'stepNumber': '3',
            'stepName': 'Enter mobile number and password'
        });
        this.$validator.updateDictionary({
            en: {
                custom: {
                    mobileNumber: {
                        required: 'Please enter your mobile number',
                    },
                    password: {
                        required: 'Please set up a password'
                    },
                    agree: {
                        required: 'Please agree to sign up'
                    },
                }
            }
        });
    };
    FreshRegistrationPage.prototype.toggleShowPassword = function () {
        this.$refs.passwordField['type'] = this.$refs.passwordField['type'] == 'password' ? 'text' : 'password';
        this.$refs.passwordField['focus']();
    };
    FreshRegistrationPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.loading = true;
            var password = _this.$refs.passwordField.value;
            var clubcardUser = new __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["c" /* ClubCardUser */]({
                firstName: _this.$store.state.firstName || _this.$store.state.formFirstName,
                lastName: _this.$store.state.lastName || _this.$store.state.formLastName,
                email: _this.$store.state.email,
                password: password,
                phone: _this.$store.state.mobileNumber,
                securityAnswer: '',
                clubCard: '',
                securityQuestion: new __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["d" /* SecurityQuestion */]({
                    id: '',
                    text: ''
                }),
                agreedToMarketing: _this.$store.state.agreeComms
            });
            __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].completeRegistration(clubcardUser).then(function (response) {
                dataLayer.push({
                    'event': 'successfulSubmission',
                    'memberStatus': false
                });
                _this.autologin(response);
            }).catch(function (error) {
                _this.handleRegistrationError(error);
            });
        });
    };
    FreshRegistrationPage.prototype.autologin = function (response) {
        document.location.href = document.location.href + ("?customer_id=" + encodeURIComponent(response.userId) + "&access_token=" + encodeURIComponent(response.token) + "&anonymous_id=2323&refresh_token=" + encodeURIComponent(response.refresh) + "&status=" + encodeURIComponent(response.status));
        var customerId = response.userId;
        dataLayer.push({
            'event': 'BPIDAvailable',
            'BPID': customerId
        });
    };
    FreshRegistrationPage.prototype.handleRegistrationError = function (error) {
        if (error && error.response && error.response.data && error.response.data.message) {
            if (error.response.data.message == 'This phone number is not valid') {
                this.invalidateField('phoneNumber', 'This phone number is not valid');
            }
            else {
                this.handleApiError(error);
            }
        }
        else {
            this.handleApiError(error);
        }
        this.loading = false;
    };
    FreshRegistrationPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(257) })
    ], FreshRegistrationPage);
    return FreshRegistrationPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SecurityEntryPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_entry_scss__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_entry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__security_entry_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var SecurityEntryPage = (function (_super) {
    __extends(SecurityEntryPage, _super);
    function SecurityEntryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.termsVisible = false;
        _this.showPassword = false;
        _this.passwordFocused = false;
        _this.loading = false;
        _this.comms = false;
        _this.some = false;
        _this.agree = false;
        return _this;
    }
    SecurityEntryPage.prototype.mounted = function () {
        dataLayer.push({
            'event': 'stepLoaded',
            'stepNumber': '3',
            'stepName': 'Enter details to complete sign up'
        });
        if (!this.$store.state.phoneNumber && this.$store.state.presetPhoneNumber) {
            this.$store.state.phoneNumber = this.$store.state.presetPhoneNumber;
        }
        this.$validator.updateDictionary({
            en: {
                custom: {
                    phoneNumber: {
                        required: 'Please enter your phone number'
                    },
                    password: {
                        required: 'You need to set up the password'
                    },
                    answer: {
                        required: 'Please enter the answer for the question'
                    },
                    agree: {
                        required: 'We need you to agree to proceed'
                    },
                    title: {
                        required: 'Please select your title'
                    }
                }
            }
        });
    };
    SecurityEntryPage.prototype.toggleShowPassword = function () {
        this.$refs.passwordField['type'] = this.$refs.passwordField['type'] == 'password' ? 'text' : 'password';
        this.$refs.passwordField['focus']();
    };
    SecurityEntryPage.prototype.next = function () {
        var _this = this;
        this.doIfFormIsValid(function () {
            _this.loading = true;
            var password = _this.$refs.passwordField.value;
            if (_this.$store.state.isQuickShopper) {
                var quickShopperUser = new __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["b" /* Shopper */]({
                    firstName: _this.$store.state.firstName,
                    lastName: _this.$store.state.lastName,
                    email: _this.$store.state.email,
                    password: password,
                    phone: _this.$store.state.phoneNumber,
                    agreedToTermsAndConditions: true,
                    agreedToMarketing: _this.$store.state.agreeComms
                });
                __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].registerUser(quickShopperUser).then(function (response) {
                    dataLayer.push({
                        'event': 'successfulSubmission',
                        'memberStatus': memberStatus
                    });
                    _this.autologin(response);
                }).catch(function (error) {
                    _this.handleRegistrationError(error);
                });
            }
            else {
                var clubcardUser = new __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["c" /* ClubCardUser */]({
                    firstName: _this.$store.state.firstName,
                    lastName: _this.$store.state.lastName,
                    email: _this.$store.state.email,
                    password: password,
                    phone: _this.$store.state.phoneNumber,
                    securityQuestion: _this.$store.state.securityQuestions[_this.$store.state.securityQuestion],
                    securityAnswer: _this.$store.state.securityAnswer,
                    clubCard: _this.$store.state.clubcardNumber.replace(/ /g, ''),
                    agreedToMarketing: _this.$store.state.agreeComms,
                    title: _this.$store.state.title
                });
                __WEBPACK_IMPORTED_MODULE_1__services_generated_edge_user__["a" /* UserApiService */].completeRegistration(clubcardUser).then(function (response) {
                    dataLayer.push({
                        'event': 'successfulSubmission',
                        'memberStatus': memberStatus
                    });
                    _this.autologin(response);
                }).catch(function (error) {
                    _this.handleRegistrationError(error);
                });
            }
        });
    };
    SecurityEntryPage.prototype.autologin = function (response) {
        document.location.href = document.location.href + ("?customer_id=" + encodeURIComponent(response.userId) + "&access_token=" + encodeURIComponent(response.token) + "&anonymous_id=2323&refresh_token=" + encodeURIComponent(response.refresh) + "&status=" + encodeURIComponent(response.status));
        var customerId = response.userId;
        dataLayer.push({
            'event': 'BPIDAvailable',
            'BPID': customerId
        });
    };
    SecurityEntryPage.prototype.handleRegistrationError = function (error) {
        if (error && error.response && error.response.data && error.response.data.message) {
            if (error.response.data.message == 'This phone number is not valid') {
                this.invalidateField('phoneNumber', 'This phone number is not valid');
            }
            else {
                this.handleApiError(error);
            }
        }
        else {
            this.handleApiError(error);
        }
        this.loading = false;
    };
    SecurityEntryPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default()({ template: __webpack_require__(258) })
    ], SecurityEntryPage);
    return SecurityEntryPage;
}(__WEBPACK_IMPORTED_MODULE_2__registration_vue__["a" /* RegistrationVue */]));



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailRegisteredPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EmailRegisteredPage = (function (_super) {
    __extends(EmailRegisteredPage, _super);
    function EmailRegisteredPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailRegisteredPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            template: "\n<registration-page centered=\"true\">\n  <h1 id=\"qa-user-exists-header-msg\">It looks like you already have a login.</h1>\n  <p>You can use your existing New World Clubcard login and password to log in to I shop New World</p>\n  <p class=\"qa-login-button\">Press X above to close Sign-up and then logon</p>\n</registration-page>\n"
        })
    ], EmailRegisteredPage);
    return EmailRegisteredPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));



/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationErrorPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var RegistrationErrorPage = (function (_super) {
    __extends(RegistrationErrorPage, _super);
    function RegistrationErrorPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegistrationErrorPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            template: "\n<registration-page centered=\"true\">\n    <h1>Oops</h1>\n    <p>We've encountered a problem setting up your account, please call us 0800 80 70 70.</p>\n</registration-page>\n"
        })
    ], RegistrationErrorPage);
    return RegistrationErrorPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));



/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * smooth-scroll v11.1.0: Animate scrolling to anchor links
 * (c) 2017 Chris Ferdinandi
 * GPL-3.0 License
 * http://github.com/cferdinandi/smooth-scroll
 */

(function (root, factory) {
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory(root)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.smoothScroll = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, (function (root) {

	'use strict';

	//
	// Variables
	//

	var smoothScroll = {}; // Object for public APIs
	var supports = 'querySelector' in document && 'addEventListener' in root; // Feature test
	var settings, anchor, toggle, fixedHeader, headerHeight, eventTimeout, animationInterval;

	// Default settings
	var defaults = {
		// Selectors
		selector: '[data-scroll]',
		ignore: '[data-scroll-ignore]',
		selectorHeader: null,

		// Speed & Easing
		speed: 500,
		offset: 0,
		easing: 'easeInOutCubic',
		easingPatterns: {},

		// Callback API
		before: function () {},
		after: function () {}
	};


	//
	// Methods
	//

	/**
	 * Merge two or more objects. Returns a new object.
	 * @private
	 * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	 * @param {Object}   objects  The objects to merge together
	 * @returns {Object}          Merged values of defaults and options
	 */
	var extend = function () {

		// Variables
		var extended = {};
		var deep = false;
		var i = 0;
		var length = arguments.length;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for ( var prop in obj ) {
				if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {
					// If deep merge and property is an object, merge properties
					if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {
						extended[prop] = extend( true, extended[prop], obj[prop] );
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for ( ; i < length; i++ ) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;

	};

	/**
	 * Get the height of an element.
	 * @private
	 * @param  {Node} elem The element to get the height of
	 * @return {Number}    The element's height in pixels
	 */
	var getHeight = function ( elem ) {
		return Math.max( elem.scrollHeight, elem.offsetHeight, elem.clientHeight );
	};

	/**
	 * Get the closest matching element up the DOM tree.
	 * @private
	 * @param  {Element} elem     Starting element
	 * @param  {String}  selector Selector to match against
	 * @return {Boolean|Element}  Returns null if not match found
	 */
	var getClosest = function ( elem, selector ) {

		// Element.matches() polyfill
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function(s) {
					var matches = (this.document || this.ownerDocument).querySelectorAll(s),
						i = matches.length;
					while (--i >= 0 && matches.item(i) !== this) {}
					return i > -1;
				};
		}

		// Get closest match
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}

		return null;

	};

	/**
	 * Escape special characters for use with querySelector
	 * @private
	 * @param {String} id The anchor ID to escape
	 * @author Mathias Bynens
	 * @link https://github.com/mathiasbynens/CSS.escape
	 */
	var escapeCharacters = function ( id ) {

		// Remove leading hash
		if ( id.charAt(0) === '#' ) {
			id = id.substr(1);
		}

		var string = String(id);
		var length = string.length;
		var index = -1;
		var codeUnit;
		var result = '';
		var firstCodeUnit = string.charCodeAt(0);
		while (++index < length) {
			codeUnit = string.charCodeAt(index);
			// Note: there’s no need to special-case astral symbols, surrogate
			// pairs, or lone surrogates.

			// If the character is NULL (U+0000), then throw an
			// `InvalidCharacterError` exception and terminate these steps.
			if (codeUnit === 0x0000) {
				throw new InvalidCharacterError(
					'Invalid character: the input contains U+0000.'
				);
			}

			if (
				// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
				// U+007F, […]
				(codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F ||
				// If the character is the first character and is in the range [0-9]
				// (U+0030 to U+0039), […]
				(index === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
				// If the character is the second character and is in the range [0-9]
				// (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
				(
					index === 1 &&
					codeUnit >= 0x0030 && codeUnit <= 0x0039 &&
					firstCodeUnit === 0x002D
				)
			) {
				// http://dev.w3.org/csswg/cssom/#escape-a-character-as-code-point
				result += '\\' + codeUnit.toString(16) + ' ';
				continue;
			}

			// If the character is not handled by one of the above rules and is
			// greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
			// is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
			// U+005A), or [a-z] (U+0061 to U+007A), […]
			if (
				codeUnit >= 0x0080 ||
				codeUnit === 0x002D ||
				codeUnit === 0x005F ||
				codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
				codeUnit >= 0x0041 && codeUnit <= 0x005A ||
				codeUnit >= 0x0061 && codeUnit <= 0x007A
			) {
				// the character itself
				result += string.charAt(index);
				continue;
			}

			// Otherwise, the escaped character.
			// http://dev.w3.org/csswg/cssom/#escape-a-character
			result += '\\' + string.charAt(index);

		}

		return '#' + result;

	};

	/**
	 * Calculate the easing pattern
	 * @private
	 * @link https://gist.github.com/gre/1650294
	 * @param {String} type Easing pattern
	 * @param {Number} time Time animation should take to complete
	 * @returns {Number}
	 */
	var easingPattern = function ( settings, time ) {
		var pattern;

		// Default Easing Patterns
		if ( settings.easing === 'easeInQuad' ) pattern = time * time; // accelerating from zero velocity
		if ( settings.easing === 'easeOutQuad' ) pattern = time * (2 - time); // decelerating to zero velocity
		if ( settings.easing === 'easeInOutQuad' ) pattern = time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
		if ( settings.easing === 'easeInCubic' ) pattern = time * time * time; // accelerating from zero velocity
		if ( settings.easing === 'easeOutCubic' ) pattern = (--time) * time * time + 1; // decelerating to zero velocity
		if ( settings.easing === 'easeInOutCubic' ) pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
		if ( settings.easing === 'easeInQuart' ) pattern = time * time * time * time; // accelerating from zero velocity
		if ( settings.easing === 'easeOutQuart' ) pattern = 1 - (--time) * time * time * time; // decelerating to zero velocity
		if ( settings.easing === 'easeInOutQuart' ) pattern = time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
		if ( settings.easing === 'easeInQuint' ) pattern = time * time * time * time * time; // accelerating from zero velocity
		if ( settings.easing === 'easeOutQuint' ) pattern = 1 + (--time) * time * time * time * time; // decelerating to zero velocity
		if ( settings.easing === 'easeInOutQuint' ) pattern = time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration

		// Custom Easing Patterns
		if ( settings.easingPatterns[settings.easing] ) {
			pattern = settings.easingPatterns[settings.easing]( time );
		}

		return pattern || time; // no easing, no acceleration
	};

	/**
	 * Calculate how far to scroll
	 * @private
	 * @param {Element} anchor The anchor element to scroll to
	 * @param {Number} headerHeight Height of a fixed header, if any
	 * @param {Number} offset Number of pixels by which to offset scroll
	 * @returns {Number}
	 */
	var getEndLocation = function ( anchor, headerHeight, offset ) {
		var location = 0;
		if (anchor.offsetParent) {
			do {
				location += anchor.offsetTop;
				anchor = anchor.offsetParent;
			} while (anchor);
		}
		location = Math.max(location - headerHeight - offset, 0);
		return Math.min(location, getDocumentHeight() - getViewportHeight());
	};

	/**
	 * Determine the viewport's height
	 * @private
	 * @returns {Number}
	 */
	var getViewportHeight = function() {
		return Math.max( document.documentElement.clientHeight, root.innerHeight || 0 );
	};

	/**
	 * Determine the document's height
	 * @private
	 * @returns {Number}
	 */
	var getDocumentHeight = function () {
		return Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);
	};

	/**
	 * Convert data-options attribute into an object of key/value pairs
	 * @private
	 * @param {String} options Link-specific options as a data attribute string
	 * @returns {Object}
	 */
	var getDataOptions = function ( options ) {
		return !options || !(typeof JSON === 'object' && typeof JSON.parse === 'function') ? {} : JSON.parse( options );
	};

	/**
	 * Get the height of the fixed header
	 * @private
	 * @param  {Node}   header The header
	 * @return {Number}        The height of the header
	 */
	var getHeaderHeight = function ( header ) {
		return !header ? 0 : ( getHeight( header ) + header.offsetTop );
	};

	/**
	 * Bring the anchored element into focus
	 * @private
	 */
	var adjustFocus = function ( anchor, endLocation, isNum ) {

		// Don't run if scrolling to a number on the page
		if ( isNum ) return;

		// Otherwise, bring anchor element into focus
		anchor.focus();
		if ( document.activeElement.id !== anchor.id ) {
			anchor.setAttribute( 'tabindex', '-1' );
			anchor.focus();
			anchor.style.outline = 'none';
		}
		root.scrollTo( 0 , endLocation );

	};

	/**
	 * Start/stop the scrolling animation
	 * @public
	 * @param {Node|Number} anchor  The element or position to scroll to
	 * @param {Element}     toggle  The element that toggled the scroll event
	 * @param {Object}      options
	 */
	smoothScroll.animateScroll = function ( anchor, toggle, options ) {

		// Options and overrides
		var overrides = getDataOptions( toggle ? toggle.getAttribute('data-options') : null );
		var animateSettings = extend( settings || defaults, options || {}, overrides ); // Merge user options with defaults

		// Selectors and variables
		var isNum = Object.prototype.toString.call( anchor ) === '[object Number]' ? true : false;
		var anchorElem = isNum || !anchor.tagName ? null : anchor;
		if ( !isNum && !anchorElem ) return;
		var startLocation = root.pageYOffset; // Current location on the page
		if ( animateSettings.selectorHeader && !fixedHeader ) {
			// Get the fixed header if not already set
			fixedHeader = document.querySelector( animateSettings.selectorHeader );
		}
		if ( !headerHeight ) {
			// Get the height of a fixed header if one exists and not already set
			headerHeight = getHeaderHeight( fixedHeader );
		}
		var endLocation = isNum ? anchor : getEndLocation( anchorElem, headerHeight, parseInt((typeof animateSettings.offset === 'function' ? animateSettings.offset() : animateSettings.offset), 10) ); // Location to scroll to
		var distance = endLocation - startLocation; // distance to travel
		var documentHeight = getDocumentHeight();
		var timeLapsed = 0;
		var percentage, position;

		/**
		 * Stop the scroll animation when it reaches its target (or the bottom/top of page)
		 * @private
		 * @param {Number} position Current position on the page
		 * @param {Number} endLocation Scroll to location
		 * @param {Number} animationInterval How much to scroll on this loop
		 */
		var stopAnimateScroll = function ( position, endLocation, animationInterval ) {
			var currentLocation = root.pageYOffset;
			if ( position == endLocation || currentLocation == endLocation || ( (root.innerHeight + currentLocation) >= documentHeight ) ) {

				// Clear the animation timer
				clearInterval(animationInterval);

				// Bring the anchored element into focus
				adjustFocus( anchor, endLocation, isNum );

				// Run callback after animation complete
				animateSettings.after( anchor, toggle );

			}
		};

		/**
		 * Loop scrolling animation
		 * @private
		 */
		var loopAnimateScroll = function () {
			timeLapsed += 16;
			percentage = ( timeLapsed / parseInt(animateSettings.speed, 10) );
			percentage = ( percentage > 1 ) ? 1 : percentage;
			position = startLocation + ( distance * easingPattern(animateSettings, percentage) );
			root.scrollTo( 0, Math.floor(position) );
			stopAnimateScroll(position, endLocation, animationInterval);
		};

		/**
		 * Set interval timer
		 * @private
		 */
		var startAnimateScroll = function () {
			clearInterval(animationInterval);
			animationInterval = setInterval(loopAnimateScroll, 16);
		};

		/**
		 * Reset position to fix weird iOS bug
		 * @link https://github.com/cferdinandi/smooth-scroll/issues/45
		 */
		if ( root.pageYOffset === 0 ) {
			root.scrollTo( 0, 0 );
		}

		// Run callback before animation starts
		animateSettings.before( anchor, toggle );

		// Start scrolling animation
		startAnimateScroll();

	};

	/**
	 * Handle has change event
	 * @private
	 */
	var hashChangeHandler = function (event) {

		// Get hash from URL
		var hash;
		try {
			hash = escapeCharacters( decodeURIComponent( root.location.hash ) );
		} catch(e) {
			hash = escapeCharacters( root.location.hash );
		}

		// Only run if there's an anchor element to scroll to
		if ( !anchor ) return;

		// Reset the anchor element's ID
		anchor.id = anchor.getAttribute( 'data-scroll-id' );

		// Scroll to the anchored content
		smoothScroll.animateScroll( anchor, toggle );

		// Reset anchor and toggle
		anchor = null;
		toggle = null;

	};

	/**
	 * If smooth scroll element clicked, animate scroll
	 * @private
	 */
	var clickHandler = function (event) {

		// Don't run if right-click or command/control + click
		if ( event.button !== 0 || event.metaKey || event.ctrlKey ) return;

		// Check if a smooth scroll link was clicked
		toggle = getClosest( event.target, settings.selector );
		if ( !toggle || toggle.tagName.toLowerCase() !== 'a' || getClosest( event.target, settings.ignore ) ) return;

		// Only run if link is an anchor and points to the current page
		if ( toggle.hostname !== root.location.hostname || toggle.pathname !== root.location.pathname || !/#/.test(toggle.href) ) return;

		// Get the sanitized hash
		var hash;
		try {
			hash = escapeCharacters( decodeURIComponent( toggle.hash ) );
		} catch(e) {
			hash = escapeCharacters( toggle.hash );
		}

		// If the hash is empty, scroll to the top of the page
		if ( hash === '#' ) {

			// Prevent default link behavior
			event.preventDefault();

			// Set the anchored element
			anchor = document.body;

			// Save or create the ID as a data attribute and remove it (prevents scroll jump)
			var id = anchor.id ? anchor.id : 'smooth-scroll-top';
			anchor.setAttribute( 'data-scroll-id', id );
			anchor.id = '';

			// If no hash change event will happen, fire manually
			// Otherwise, update the hash
			if ( root.location.hash.substring(1) === id ) {
				hashChangeHandler();
			} else {
				root.location.hash = id;
			}

			return;

		}

		// Get the anchored element
		anchor = document.querySelector( hash );

		// If anchored element exists, save the ID as a data attribute and remove it (prevents scroll jump)
		if ( !anchor ) return;
		anchor.setAttribute( 'data-scroll-id', anchor.id );
		anchor.id = '';

		// If no hash change event will happen, fire manually
		if ( toggle.hash === root.location.hash ) {
			event.preventDefault();
			hashChangeHandler();
		}

	};

	/**
	 * On window scroll and resize, only run events at a rate of 15fps for better performance
	 * @private
	 * @param  {Function} eventTimeout Timeout function
	 * @param  {Object} settings
	 */
	var resizeThrottler = function (event) {
		if ( !eventTimeout ) {
			eventTimeout = setTimeout((function() {
				eventTimeout = null; // Reset timeout
				headerHeight = getHeaderHeight( fixedHeader ); // Get the height of a fixed header if one exists
			}), 66);
		}
	};

	/**
	 * Destroy the current initialization.
	 * @public
	 */
	smoothScroll.destroy = function () {

		// If plugin isn't already initialized, stop
		if ( !settings ) return;

		// Remove event listeners
		document.removeEventListener( 'click', clickHandler, false );
		root.removeEventListener( 'resize', resizeThrottler, false );

		// Reset varaibles
		settings = null;
		anchor = null;
		toggle = null;
		fixedHeader = null;
		headerHeight = null;
		eventTimeout = null;
		animationInterval = null;
	};

	/**
	 * Initialize Smooth Scroll
	 * @public
	 * @param {Object} options User settings
	 */
	smoothScroll.init = function ( options ) {

		// feature test
		if ( !supports ) return;

		// Destroy any existing initializations
		smoothScroll.destroy();

		// Selectors and variables
		settings = extend( defaults, options || {} ); // Merge user options with defaults
		fixedHeader = settings.selectorHeader ? document.querySelector( settings.selectorHeader ) : null; // Get the fixed header
		headerHeight = getHeaderHeight( fixedHeader );

		// When a toggle is clicked, run the click handler
		document.addEventListener( 'click', clickHandler, false );

		// Listen for hash changes
		root.addEventListener('hashchange', hashChangeHandler, false);

		// If window is resized and there's a fixed header, recalculate its size
		if ( fixedHeader ) {
			root.addEventListener( 'resize', resizeThrottler, false );
		}

	};


	//
	// Public APIs
	//

	return smoothScroll;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 281 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[265]);


// WEBPACK FOOTER //
// static/js/app.81513eed2ac385a9b6cd.js